function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "MCIU-sin-svg");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.81 30.57c-0.23 0-0.42-0.18-0.42-0.41 0-0.22 0.19-0.41 0.42-0.41 0.23 0 0.42 0.19 0.42 0.41 0 0.23-0.19 0.41-0.42 0.41z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.81 36.34c-1.11 0-2.1-0.1-2.86-0.3 0.76-0.21 1.76-0.33 2.86-0.34 1.1 0.01 2.1 0.13 2.86 0.34-0.76 0.2-1.76 0.3-2.86 0.3z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.13 42.24h7.36v37.52h-7.36z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.13 42.24h7.36v37.52h-7.36z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m82.34 36.34c-1.1 0-2.1-0.1-2.86-0.3 0.76-0.21 1.76-0.33 2.86-0.34 1.1 0.01 2.1 0.13 2.86 0.34-0.76 0.2-1.76 0.3-2.86 0.3z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m82.34 31c-0.23 0-0.41-0.18-0.41-0.41 0-0.23 0.18-0.41 0.41-0.41 0.24 0 0.42 0.18 0.42 0.41 0 0.23-0.18 0.41-0.42 0.41z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp7"
}, /*#__PURE__*/React.createElement("path", {
  d: "m78.69 42.24h7.36v37.52h-7.36z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp8"
}, /*#__PURE__*/React.createElement("path", {
  d: "m78.69 42.24h7.36v37.52h-7.36z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp9"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.52 35.59c-5.01 0-9.54-0.61-12.99-1.53 3.45-0.93 7.98-1.5 12.99-1.51 5.01 0.01 9.56 0.58 13.01 1.51-3.45 0.92-8 1.53-13.01 1.53z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp10"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.52 35.59c-5.01 0-9.54-0.61-12.99-1.53 3.45-0.93 7.98-1.5 12.99-1.51 5.01 0.01 9.56 0.58 13.01 1.51-3.45 0.92-8 1.53-13.01 1.53z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp11"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.52 35.59c-5.01 0-9.54-0.61-12.99-1.53 3.45-0.93 7.98-1.5 12.99-1.51 5.01 0.01 9.56 0.58 13.01 1.51-3.45 0.92-8 1.53-13.01 1.53z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp12"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.52 35.59c-5.01 0-9.54-0.61-12.99-1.53 3.45-0.93 7.98-1.5 12.99-1.51 5.01 0.01 9.56 0.58 13.01 1.51-3.45 0.92-8 1.53-13.01 1.53z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp13"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.49 10.59c-1.11 0-2.01-0.88-2.01-1.98 0-1.09 0.9-1.97 2.01-1.97 1.1 0 2 0.88 2 1.97 0 1.1-0.9 1.98-2 1.98z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp14"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.47 10.66c-1.11 0-2.01-0.88-2.01-1.98 0-1.09 0.9-1.97 2.01-1.97 1.1 0 2 0.88 2 1.97 0 1.1-0.9 1.98-2 1.98z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp15"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.6 77.99c0 6.2-5.05 11.22-11.34 11.22-6.29 0-11.39-5.02-11.39-11.22v-15.71h22.73c0 0 0 15.71 0 15.71z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp16"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.6 77.99c0 6.2-5.05 11.22-11.34 11.22-6.29 0-11.39-5.02-11.39-11.22v-15.71h22.73c0 0 0 15.71 0 15.71z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp17"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.6 77.99c0 6.2-5.05 11.22-11.34 11.22-6.29 0-11.39-5.02-11.39-11.22v-15.71h22.73c0 0 0 15.71 0 15.71z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp18"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.6 77.99c0 6.2-5.05 11.22-11.34 11.22-6.29 0-11.39-5.02-11.39-11.22v-15.71h22.73c0 0 0 15.71 0 15.71z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "cp19"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.6 77.99c0 6.2-5.05 11.22-11.34 11.22-6.29 0-11.39-5.02-11.39-11.22v-15.71h22.73c0 0 0 15.71 0 15.71z"
})));

var _ref4 = /*#__PURE__*/React.createElement("style", null, "\n    .s0 {\n      fill: none;\n    }\n    .s1 {\n      fill: #211915;\n    }\n    .s2 {\n      fill: #b60027;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s3 {\n      fill: #a07e00;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s4 {\n      fill: #a07e00;\n    }\n    .s5 {\n      fill: none;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s6 {\n      fill: #ffffff;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s7 {\n      fill: #006f46;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s8 {\n      fill: #b60027;\n    }\n    .s9 {\n      fill: #0044ae;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s10 {\n      fill: #bcbab9;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s11 {\n      fill: #bcbab9;\n    }\n    .s12 {\n      fill: none;\n      stroke: #211915;\n      stroke-linecap: round;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s13 {\n      fill: none;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.5;\n    }\n    .s14 {\n      fill: none;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.6;\n    }\n    .s15 {\n      fill: #0044ae;\n    }\n    .s16 {\n      fill: none;\n      stroke: #b60027;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s17 {\n      fill: #a07e00;\n      stroke: #a07e00;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s18 {\n      fill: #006f46;\n    }\n    .s19 {\n      fill: #d95aaf;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s20 {\n      fill: #211915;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n    .s21 {\n      fill: #f7cc7e;\n      stroke: #211915;\n      stroke-miterlimit: 3.8637;\n      stroke-width: 0.4;\n    }\n  ");

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fondo"
}), /*#__PURE__*/React.createElement("g", {
  id: "Gu\\xEDas"
}), /*#__PURE__*/React.createElement("g", {
  id: "Primer_plano"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m108.9 34h192.4v50h-192.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m118.6 35.4h1.5v10.6h-1.6v-8.2l-3.3 4.1h-0.3l-3.3-4.1v8.2h-1.6v-10.6h1.5l3.6 4.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m122.4 35.4h1.5v10.6h-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m134.9 35.4h1.4v10.6h-1.3l-7.2-8.1v8.1h-1.4v-10.6h1.2l7.3 8.3c0 0 0-8.3 0-8.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m138.7 35.4h1.5v10.6h-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m145.3 41.6l-1.2-0.7q-1.1-0.7-1.6-1.3-0.5-0.7-0.5-1.5 0-1.2 0.9-2 0.9-0.8 2.3-0.8 1.4 0 2.5 0.7v1.8q-1.2-1.1-2.5-1.1-0.8 0-1.3 0.3-0.4 0.3-0.4 0.9 0 0.5 0.3 0.9 0.4 0.4 1.2 0.9l1.1 0.6q2 1.2 2 3 0 1.3-0.8 2.1-0.9 0.8-2.3 0.8-1.6 0-2.9-1v-1.9q1.2 1.5 2.9 1.5 0.7 0 1.2-0.4 0.5-0.4 0.5-1 0-0.9-1.5-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m148.9 35.4h9v1.4h-3.8v9.2h-1.5v-9.2h-3.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m159.3 35.4h6.1v1.4h-4.5v3.2h4.4v1.4h-4.4v3.3h4.7v1.3h-6.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m167.3 46v-10.6h2.7q1.6 0 2.6 0.8 0.9 0.8 0.9 2.2 0 0.9-0.4 1.6-0.5 0.7-1.4 1 0.5 0.3 1 0.9 0.5 0.6 1.4 2 0.6 0.9 0.9 1.4l0.6 0.7h-1.9l-0.4-0.7q-0.1 0-0.1-0.1l-0.3-0.4-0.5-0.8-0.5-0.8q-0.5-0.7-0.9-1.1-0.4-0.3-0.7-0.5-0.3-0.2-1.1-0.2h-0.4v4.6c0 0-1.5 0-1.5 0zm2-9.3h-0.5v3.4h0.6q1.2 0 1.6-0.2 0.4-0.2 0.7-0.6 0.2-0.4 0.2-0.9 0-0.5-0.2-0.9-0.3-0.4-0.8-0.6-0.5-0.2-1.6-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m176.8 35.4h1.5v10.6h-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m186 35.3q2.5 0 4.1 1.5 1.7 1.6 1.7 3.9 0 2.4-1.7 3.9-1.6 1.6-4.2 1.6-2.4 0-4-1.6-1.7-1.5-1.7-3.8 0-2.4 1.7-4 1.6-1.5 4.1-1.5zm0.1 1.4q-1.9 0-3.1 1.2-1.2 1.1-1.2 2.9 0 1.7 1.2 2.8 1.2 1.2 3 1.2 1.8 0 3-1.2 1.2-1.2 1.2-2.9 0-1.7-1.2-2.8-1.2-1.2-2.9-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m110.1 62.7v-10.6h3.6q2.2 0 3.5 0.7 1.3 0.6 2 1.9 0.8 1.3 0.8 2.7 0 1.1-0.5 2.1-0.4 1-1.1 1.7-0.8 0.8-1.9 1.1-0.6 0.3-1.1 0.4-0.5 0-1.9 0zm3.4-9.2h-1.9v7.9h2q1.1 0 1.8-0.2 0.6-0.1 1-0.4 0.5-0.2 0.8-0.6 1.2-1.1 1.2-2.8 0-1.7-1.2-2.8-0.4-0.4-1-0.7-0.5-0.2-1-0.3-0.5-0.1-1.7-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m121.9 52.1h6.1v1.4h-4.6v3.2h4.4v1.4h-4.4v3.3h4.7v1.3h-6.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m143.4 60.3v1.7q-1.7 0.9-3.9 0.9-1.8 0-3-0.7-1.3-0.8-2-2-0.8-1.3-0.8-2.7 0-2.3 1.7-3.9 1.7-1.6 4.2-1.6 1.6 0 3.7 0.9v1.6q-1.9-1.1-3.7-1.1-1.8 0-3 1.2-1.3 1.1-1.3 2.9 0 1.7 1.2 2.8 1.2 1.2 3.1 1.2 2 0 3.8-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m145.3 52.1h1.6v10.6h-1.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m149.3 52.1h6.1v1.4h-4.6v3.2h4.4v1.4h-4.4v3.3h4.7v1.3h-6.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m165.7 52.1h1.5v10.6h-1.3l-7.2-8.1v8.1h-1.5v-10.6h1.3l7.2 8.3c0 0 0-8.3 0-8.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m178.8 60.3v1.7q-1.7 0.9-3.9 0.9-1.9 0-3.1-0.7-1.3-0.8-2-2-0.7-1.3-0.7-2.7 0-2.3 1.6-3.9 1.7-1.6 4.2-1.6 1.7 0 3.8 0.9v1.6q-1.9-1.1-3.7-1.1-1.9 0-3.1 1.2-1.2 1.1-1.2 2.9 0 1.7 1.2 2.8 1.2 1.2 3 1.2 2 0 3.9-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m180.7 52.1h1.5v10.6h-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m188 52.1h1.1l4.9 10.6h-1.6l-1.5-3.1h-4.6l-1.3 3.1h-1.6zm2.3 6.2l-1.8-3.8-1.6 3.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m194.7 64.6v-0.3q0.4-0.3 0.5-0.7 0.1-0.3 0.2-0.9-0.9-0.2-0.9-0.9 0-0.5 0.3-0.8 0.3-0.3 0.7-0.3 0.5 0 0.8 0.5 0.3 0.4 0.3 1 0 0.8-0.5 1.5-0.5 0.6-1.4 0.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m201.6 52.1h1.6v10.6h-1.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m214.1 52.1h1.5v10.6h-1.3l-7.2-8.1v8.1h-1.5v-10.6h1.3l7.2 8.3c0 0 0-8.3 0-8.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m226.4 52.1h1.5v10.6h-1.3l-7.2-8.1v8.1h-1.5v-10.6h1.3l7.2 8.3c0 0 0-8.3 0-8.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m235.5 52q2.5 0 4.1 1.5 1.7 1.6 1.7 3.9 0 2.4-1.7 3.9-1.6 1.6-4.2 1.6-2.4 0-4.1-1.6-1.6-1.5-1.6-3.8 0-2.4 1.7-4 1.6-1.5 4.1-1.5zm0 1.4q-1.8 0-3 1.2-1.2 1.1-1.2 2.9 0 1.7 1.2 2.8 1.2 1.2 3 1.2 1.8 0 3-1.2 1.2-1.2 1.2-2.9 0-1.7-1.2-2.8-1.2-1.2-3-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m249.5 52.1h1.5l-4.6 10.7h-0.3l-4.6-10.7h1.5l3.2 7.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m254.5 52.1h1.1l4.8 10.6h-1.5l-1.5-3.1h-4.6l-1.3 3.1h-1.6zm2.3 6.2l-1.8-3.8-1.6 3.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m270.4 60.3v1.7q-1.7 0.9-4 0.9-1.8 0-3-0.7-1.3-0.8-2-2-0.7-1.3-0.7-2.7 0-2.3 1.6-3.9 1.7-1.6 4.2-1.6 1.7 0 3.7 0.9v1.6q-1.8-1.1-3.7-1.1-1.8 0-3 1.2-1.2 1.1-1.2 2.9 0 1.7 1.2 2.8 1.2 1.2 3 1.2 2 0 3.9-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m272.3 52.1h1.5v10.6h-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m281.5 52q2.5 0 4.1 1.5 1.7 1.6 1.7 3.9 0 2.4-1.7 3.9-1.7 1.6-4.2 1.6-2.4 0-4.1-1.6-1.6-1.5-1.6-3.8 0-2.4 1.6-4 1.7-1.5 4.2-1.5zm0 1.4q-1.8 0-3 1.2-1.2 1.1-1.2 2.9 0 1.7 1.2 2.8 1.2 1.2 3 1.2 1.8 0 3-1.2 1.2-1.2 1.2-2.9 0-1.7-1.2-2.8-1.2-1.2-3-1.2zm1.6-4.3l-1.8 2.3h-0.9l1.1-2.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m297.7 52.1h1.5v10.6h-1.3l-7.2-8.1v8.1h-1.5v-10.6h1.3l7.2 8.3c0 0 0-8.3 0-8.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m116.5 68.8h1.9l-4 5v5.7h-1.6v-5.7l-3.9-5h1.8l2.9 3.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m131.5 68.8h1.5v6.1q0 1.2-0.2 1.8-0.2 0.6-0.4 1.1-0.3 0.4-0.7 0.7-1.3 1.1-3.3 1.1-2.1 0-3.4-1.1-0.4-0.3-0.6-0.7-0.3-0.5-0.5-1.1-0.2-0.6-0.2-1.8v-6.1h1.6v6.1q0 1.5 0.3 2.1 0.4 0.5 1.1 0.9 0.7 0.3 1.7 0.3 1.3 0 2.2-0.7 0.5-0.3 0.7-0.9 0.2-0.5 0.2-1.7c0 0 0-6.1 0-6.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m143.7 68.8h1.5v10.7h-1.4l-7.2-8.2v8.2h-1.4v-10.7h1.2l7.3 8.3c0 0 0-8.3 0-8.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m147.5 68.8h1.5v10.7h-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m158.2 68.8h1.6l-4.6 10.7h-0.3l-4.7-10.7h1.6l3.2 7.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m160.9 68.8h6.1v1.4h-4.5v3.2h4.4v1.4h-4.4v3.3h4.7v1.3h-6.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m168.9 79.5v-10.7h2.7q1.6 0 2.6 0.8 0.9 0.8 0.9 2.2 0 0.9-0.4 1.6-0.5 0.7-1.4 1 0.5 0.3 1 0.9 0.5 0.6 1.4 2 0.6 0.9 0.9 1.4l0.6 0.8h-1.9l-0.4-0.7q-0.1-0.1-0.1-0.2l-0.3-0.4-0.5-0.8-0.5-0.8q-0.5-0.6-0.9-1-0.4-0.4-0.7-0.6-0.3-0.2-1.1-0.2h-0.4v4.7c0 0-1.5 0-1.5 0zm2-9.4h-0.5v3.4h0.6q1.2 0 1.6-0.2 0.4-0.2 0.7-0.6 0.2-0.4 0.2-0.9 0-0.5-0.2-0.9-0.3-0.4-0.8-0.6-0.5-0.2-1.6-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m181 75l-1.1-0.7q-1.1-0.7-1.6-1.3-0.5-0.6-0.5-1.5 0-1.2 0.9-2 0.9-0.8 2.3-0.8 1.3 0 2.5 0.8v1.7q-1.2-1.1-2.5-1.1-0.8 0-1.3 0.3-0.5 0.4-0.5 0.9 0 0.5 0.4 0.9 0.4 0.4 1.1 0.9l1.2 0.7q2 1.1 2 2.9 0 1.3-0.9 2.1-0.8 0.8-2.2 0.8-1.6 0-2.9-1v-1.9q1.2 1.5 2.9 1.5 0.7 0 1.2-0.4 0.4-0.4 0.4-1 0-0.9-1.4-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m185.6 68.8h1.5v10.7h-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m189.5 79.4v-10.6h3.7q2.2 0 3.5 0.7 1.2 0.6 2 1.9 0.7 1.3 0.7 2.8 0 1-0.4 2-0.4 1-1.2 1.7-0.7 0.8-1.8 1.1-0.6 0.3-1.1 0.4-0.5 0-1.9 0c0 0-3.5 0-3.5 0zm3.5-9.2h-1.9v7.9h2q1.1 0 1.8-0.2 0.6-0.1 1-0.4 0.5-0.2 0.8-0.6 1.1-1.1 1.1-2.8 0-1.7-1.1-2.8-0.5-0.4-1-0.7-0.6-0.2-1.1-0.3-0.5-0.1-1.6-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m204.1 68.8h1l4.9 10.7h-1.6l-1.4-3.2h-4.6l-1.4 3.2h-1.6zm2.3 6.1l-1.7-3.8-1.6 3.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m211.2 79.4v-10.6h3.6q2.2 0 3.5 0.7 1.3 0.6 2 1.9 0.8 1.3 0.8 2.8 0 1-0.5 2-0.4 1-1.1 1.7-0.8 0.8-1.9 1.1-0.6 0.3-1.1 0.4-0.5 0-1.9 0c0 0-3.4 0-3.4 0zm3.4-9.2h-1.9v7.9h2q1.1 0 1.8-0.2 0.6-0.1 1-0.4 0.5-0.2 0.8-0.6 1.2-1.1 1.2-2.8 0-1.7-1.2-2.8-0.4-0.4-1-0.7-0.6-0.2-1.1-0.3-0.5-0.1-1.6-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m223 68.8h6.1v1.4h-4.6v3.2h4.4v1.4h-4.4v3.3h4.7v1.3h-6.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s1",
  d: "m233.5 75l-1.1-0.7q-1.1-0.7-1.6-1.3-0.5-0.6-0.5-1.5 0-1.2 0.9-2 0.9-0.8 2.3-0.8 1.4 0 2.5 0.8v1.7q-1.2-1.1-2.5-1.1-0.8 0-1.3 0.3-0.4 0.4-0.4 0.9 0 0.5 0.3 0.9 0.4 0.4 1.2 0.9l1.1 0.7q2 1.1 2 2.9 0 1.3-0.9 2.1-0.8 0.8-2.2 0.8-1.6 0-2.9-1v-1.9q1.2 1.5 2.9 1.5 0.7 0 1.2-0.4 0.5-0.4 0.5-1 0-0.9-1.5-1.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m11.3 34.5c0 0-0.2 0-0.3-0.1-0.2-0.1-0.5-0.4-0.5-0.4l-0.3-0.3-0.3-0.4c0 0-0.4-0.5-0.2-0.9 0.1-0.5 0.4-0.6 0.6-0.8 0.3-0.1 0.7-0.2 0.7-0.2 0 0 0.4-0.2 0.6-0.2 0.1-0.1 0.5-0.2 0.5-0.2 0 0 0.2-0.1 0.3-0.1 0.1-0.1 0.3-0.1 0.4-0.1 0.1 0 0.4-0.1 0.5-0.1 0.3 0 0.6 0 0.8 0 0.1 0 0.5 0.1 0.7 0.1 0.2 0 0.8-0.1 1-0.1 0.2 0 0.3 0 0.5 0 0.2 0 0.6 0.2 0.7 0.2 0.1 0.1 0.7 0.3 0.9 0.4 0.3 0 0.8 0.1 1.1 0.3 0.2 0.1 0.4 0.3 0.5 0.5 0.2 0.2 0.2 0.4 0.2 0.5 0.1 0.1 0.1 0.4 0 0.5 0 0.1-0.2 0.4-0.2 0.4l-0.3 0.5-0.3 0.3c0 0-0.3 0.2-0.5 0.2-0.2 0-2.3-0.4-3.6-0.4-1.3 0-3.5 0.4-3.5 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m14.8 32.6c-0.3 0-0.6-0.5-0.6-1.2 0-0.6 0.3-1.2 0.6-1.2 0.3 0 0.6 0.6 0.6 1.2 0 0.7-0.3 1.2-0.6 1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m14.8 32.5c-0.1 0-0.3-0.5-0.3-1.1 0-0.6 0.2-1.1 0.3-1.1 0.2 0 0.3 0.5 0.3 1.1 0 0.6-0.1 1.1-0.3 1.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s4",
  d: "m14.8 30.6c-0.2 0-0.4-0.2-0.4-0.4 0-0.3 0.2-0.4 0.4-0.4 0.2 0 0.4 0.1 0.4 0.4 0 0.2-0.2 0.4-0.4 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m15.1 30v0.3h-0.6v-0.3h0.2v-0.6h-0.3v-0.3h0.3v-0.2h0.2v0.2h0.3v0.3h-0.3v0.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m15.4 30v0.3h-1.2v-0.3h0.5v-0.6h-0.3v-0.3h0.3v-0.2h0.2v0.2h0.3v0.3h-0.3v0.6z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m14.8 30.6c-0.2 0-0.4-0.2-0.4-0.4 0-0.3 0.2-0.4 0.4-0.4 0.2 0 0.4 0.1 0.4 0.4 0 0.2-0.2 0.4-0.4 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m14.8 30.6c-0.2 0-0.4-0.2-0.4-0.4 0-0.3 0.2-0.4 0.4-0.4 0.2 0 0.4 0.1 0.4 0.4 0 0.2-0.2 0.4-0.4 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m14.9 29.8c0.2 0 0.3 0.2 0.3 0.4 0 0.2-0.2 0.4-0.4 0.4-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.1-0.4 0.3-0.4"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m14.8 34.4h-2.2v-0.5l-0.1-0.6-0.1-0.7c-0.6-0.9-1.2-1.4-1.4-1.3q0.1-0.2 0.2-0.3c0.6-0.4 1.7 0.4 2.5 1.7q0.1 0.2 0.2 0.4h0.9 0.9q0.1-0.2 0.2-0.4c0.9-1.3 2-2.1 2.5-1.7q0.1 0.1 0.2 0.3c-0.2-0.1-0.7 0.4-1.3 1.3l-0.1 0.7-0.1 0.6-0.1 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m11.1 31.3c0.4-0.3 1.4 0.5 2.2 1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m18.5 31.3c-0.4-0.3-1.4 0.5-2.1 1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m11.6 35.4c-0.1-0.2-0.3-0.5-0.3-0.5 0.9-0.2 2.1-0.4 3.5-0.4 1.4 0 2.6 0.2 3.5 0.4 0 0-0.1 0.2-0.2 0.5-0.1 0.1-0.2 0.3-0.2 0.3q-1.2-0.3-3.1-0.3c-1.3 0-2.5 0.1-3.1 0.4 0 0 0-0.2-0.1-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m14.8 36.6c1.1 0 2.3-0.2 2.8-0.3 0.3-0.1 0.4-0.2 0.4-0.4q0-0.1-0.2-0.2c-0.6-0.2-1.8-0.3-3-0.3-1.2 0-2.4 0.1-3 0.3q-0.2 0.1-0.2 0.2c0 0.2 0.1 0.3 0.4 0.4 0.5 0.1 1.7 0.3 2.8 0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m18.3 34.4l-0.2-0.2c0 0-0.3 0.1-0.6 0.1-0.3-0.1-0.4-0.5-0.4-0.5 0 0-0.4 0.3-0.7 0.3-0.3 0-0.5-0.3-0.5-0.3 0 0-0.3 0.3-0.6 0.2-0.2 0-0.5-0.3-0.5-0.3 0 0-0.3 0.3-0.6 0.4-0.3 0-0.5-0.3-0.5-0.3 0 0-0.1 0.3-0.5 0.3-0.3 0.1-0.6-0.2-0.6-0.2 0 0-0.2 0.3-0.5 0.4-0.2 0.1-0.6-0.1-0.6-0.1 0 0 0 0.1 0 0.2-0.1 0-0.2 0-0.2 0l0.1 0.3c0.9-0.3 2.1-0.5 3.4-0.5 1.4 0 2.6 0.2 3.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m14.8 33.2h0.1q0 0.1 0 0.2c0 0.3 0.2 0.5 0.5 0.5 0.2 0 0.4-0.1 0.5-0.3 0 0 0-0.2 0.1-0.2 0 0 0 0.2 0 0.2 0 0.2 0.2 0.4 0.5 0.4 0.3 0 0.5-0.2 0.5-0.5q0 0 0-0.1l0.2-0.1v0.2q0 0.1 0 0.2c0 0.3 0.2 0.5 0.5 0.5q0.2 0 0.4-0.2l0.1-0.2v0.2c0 0.1 0 0.3 0.2 0.3 0 0 0.2 0 0.4-0.2 0.2-0.2 0.4-0.3 0.4-0.3v0.2c0 0-0.2 0.4-0.5 0.5-0.1 0.1-0.2 0.2-0.4 0.1-0.1 0-0.2-0.1-0.3-0.3q-0.2 0.1-0.4 0.1c-0.2 0-0.5-0.1-0.6-0.4q-0.2 0.3-0.5 0.3c-0.3 0-0.5-0.1-0.6-0.3q-0.2 0.2-0.5 0.2c-0.2 0-0.5-0.1-0.6-0.3-0.1 0.2-0.3 0.3-0.6 0.3q-0.3 0-0.5-0.2c-0.1 0.2-0.3 0.3-0.6 0.3q-0.3 0-0.5-0.3c-0.1 0.3-0.3 0.4-0.6 0.4q-0.2 0-0.4-0.1c0 0.2-0.1 0.3-0.3 0.3-0.1 0.1-0.3 0-0.4-0.1-0.2-0.1-0.5-0.5-0.5-0.5l0.1-0.2c0 0 0.1 0.1 0.3 0.3 0.3 0.2 0.4 0.2 0.4 0.2 0.2 0 0.3-0.2 0.3-0.3v-0.2l0.1 0.2q0.1 0.2 0.4 0.2c0.2 0 0.4-0.2 0.4-0.5q0-0.1 0-0.2l0.1-0.2 0.1 0.1q0 0.1 0 0.1c0 0.3 0.3 0.5 0.5 0.5 0.3 0 0.5-0.2 0.5-0.4 0 0 0-0.2 0.1-0.2 0 0 0 0.2 0 0.2 0.1 0.2 0.3 0.3 0.5 0.3 0.3 0 0.5-0.2 0.5-0.5q0-0.1 0-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m14.8 34.5c-1.4 0-2.6 0.2-3.5 0.4 0 0.1-0.1 0-0.1 0 0-0.1 0-0.2 0.1-0.2 0.9-0.3 2.1-0.5 3.5-0.5 1.4 0 2.7 0.2 3.6 0.5 0 0 0.1 0.1 0 0.2 0 0-0.1 0.1-0.1 0-0.9-0.2-2.1-0.4-3.5-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m13.7 35.2c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m14.8 35.1h-0.4c-0.1 0-0.2-0.1-0.2-0.2 0 0 0.1-0.1 0.2-0.1h0.4 0.5c0.1 0 0.1 0.1 0.1 0.1 0 0.1 0 0.2-0.1 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m12.6 35.2l-0.3 0.1c-0.1 0-0.1-0.1-0.2-0.1 0-0.1 0.1-0.2 0.2-0.2h0.3l0.3-0.1c0.1 0 0.2 0 0.2 0.1 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m11.4 35.5l0.1-0.3 0.3 0.1-0.2 0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m15.9 35.2c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m17 35.2l0.3 0.1c0.1 0 0.2-0.1 0.2-0.1 0-0.1-0.1-0.2-0.1-0.2h-0.4l-0.3-0.1c-0.1 0-0.1 0-0.2 0.1 0 0.1 0.1 0.2 0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m18.2 35.5l-0.1-0.3-0.3 0.1 0.2 0.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_3_",
  fillRule: "evenodd",
  className: "s8",
  d: "m14.8 36.3c-1.1 0-2.1-0.1-2.8-0.3 0.7-0.2 1.7-0.3 2.8-0.3 1.1 0 2.1 0.1 2.9 0.3-0.8 0.2-1.8 0.3-2.9 0.3z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m15.7 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m15.2 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m14.9 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m14.5 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m14.2 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m13.9 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m13.6 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m13.3 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m13 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m12.7 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m12.4 35.1v1.8"
}))), /*#__PURE__*/React.createElement("path", {
  id: "SVGID_3_",
  fillRule: "evenodd",
  className: "s5",
  d: "m14.8 36.3c-1.1 0-2.1-0.1-2.8-0.3 0.7-0.2 1.7-0.3 2.8-0.3 1.1 0 2.1 0.1 2.9 0.3-0.8 0.2-1.8 0.3-2.9 0.3z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m18.1 34c0 0-0.1-0.1 0-0.2 0-0.1 0.1-0.2 0.1-0.1 0.1 0 0.1 0.1 0.1 0.2 0 0-0.1 0.1-0.2 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m15.9 33.6c0 0-0.1-0.1 0-0.2 0-0.1 0-0.2 0.1-0.2 0.1 0 0.1 0.1 0.1 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m13.6 33.2c0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.1 0.2-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.1-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m11.4 33.7c0.1-0.1 0.1 0 0.2 0.1 0 0.1 0 0.2-0.1 0.2-0.1 0-0.1-0.1-0.2-0.1 0-0.1 0-0.2 0.1-0.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m14.8 32.1l-0.4 0.2 0.3 0.7 0.1 0.1 0.1-0.1 0.3-0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m14 33.1l0.1 0.2 0.6-0.1 0.1-0.1-0.1-0.1-0.6-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m15.7 33.1l-0.2 0.2-0.6-0.1-0.1-0.1 0.1-0.1 0.6-0.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m12.3 32.4l-0.3 0.3 0.4 0.5 0.1 0.1v-0.1l0.2-0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m11.6 33.5l0.3 0.2 0.5-0.3 0.1-0.1-0.1-0.1-0.6-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m13.3 33.1l-0.1 0.3-0.6-0.1h-0.1v-0.1l0.6-0.3z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m11 33.5v0.4h-0.7-0.1l0.1-0.1 0.4-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m12.5 33.5c-0.2 0-0.3-0.1-0.3-0.2 0-0.2 0.1-0.2 0.3-0.2 0.1 0 0.2 0 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m17.3 32.4l0.3 0.3-0.3 0.5-0.1 0.1-0.1-0.1-0.2-0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m18 33.5l-0.2 0.2-0.6-0.3v-0.1-0.1l0.7-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m16.3 33.1l0.1 0.3 0.7-0.1v-0.1l-0.6-0.3z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m18.5 33.5l0.1 0.4h0.6 0.1v-0.1l-0.5-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m14.8 33.3c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.3 0.2-0.3 0.1 0 0.2 0.1 0.2 0.3 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m17.2 33.5c-0.2 0-0.3-0.1-0.3-0.2 0-0.1 0.1-0.2 0.3-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m10.2 33.9c0 0-0.2-0.2-0.3-0.3-0.1-0.1-0.3-0.2-0.3-0.2 0 0 0.1-0.1 0.2-0.1q0.2 0 0.2 0.1l0.1-0.1c0 0 0.1 0 0.1 0.1 0.1 0.2 0 0.4 0 0.4 0 0 0 0.1 0 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m10.4 33.8c0.1 0.1 0.1 0.2 0.1 0.3-0.1 0-0.2 0-0.3-0.1 0 0-0.1-0.1 0-0.2 0-0.1 0.1-0.1 0.2 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m19.4 33.9c0 0 0.1-0.2 0.3-0.3 0-0.1 0.3-0.2 0.3-0.2 0 0-0.2-0.1-0.3-0.1q-0.1 0-0.2 0.1v-0.1c0 0-0.1 0-0.2 0.1 0 0.2 0 0.4 0 0.4 0 0 0 0.1 0.1 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m19.3 34c-0.1 0.1-0.2 0.1-0.2 0.1-0.1-0.1-0.1-0.2 0-0.3 0.1-0.1 0.2-0.1 0.3 0 0 0.1 0 0.2-0.1 0.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m9.8 36.5h10.1v2.8h-10.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m10.8 41.1q0.1 0 0.2 0h7.6q0.1 0 0.2 0c-0.3-0.1-0.4-0.3-0.4-0.6 0-0.3 0.2-0.6 0.4-0.6q-0.1 0-0.2 0h-7.6q-0.1 0-0.2 0h0.1c0.2 0.1 0.4 0.3 0.4 0.6 0 0.2-0.2 0.5-0.5 0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m11 41.1h7.6c0.2 0 0.5 0.1 0.5 0.3 0 0.2-0.3 0.4-0.5 0.4h-7.6c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.3 0.4-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m11 39.3h7.6c0.3 0 0.5 0.1 0.5 0.3 0 0.2-0.2 0.3-0.5 0.3h-7.6c-0.2 0-0.4-0.1-0.4-0.3 0-0.2 0.2-0.3 0.4-0.3z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m21.9 85.6c-0.7 0-1.3-0.2-1.8-0.4-0.5-0.3-1.1-0.4-1.8-0.4-0.6 0-1.3 0.1-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4-0.7 0-1.3-0.2-1.8-0.4-0.4-0.3-1-0.4-1.7-0.4-0.7 0-1.3 0.1-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4v1.1c0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1-0.4 1.7-0.4 0.7 0 1.3 0.2 1.7 0.4 0.5 0.2 1.1 0.4 1.8 0.4 0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1.1-0.4 1.7-0.4 0.7 0 1.3 0.2 1.8 0.4 0.5 0.3 1.1 0.4 1.8 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s10",
  d: "m21.9 86.7c-0.7 0-1.3-0.1-1.8-0.4-0.5-0.2-1.1-0.4-1.8-0.4-0.6 0-1.3 0.2-1.7 0.4-0.5 0.3-1.1 0.4-1.8 0.4-0.7 0-1.3-0.2-1.8-0.4-0.4-0.2-1-0.4-1.7-0.4-0.7 0-1.3 0.2-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4v1.1c0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1-0.3 1.7-0.3 0.7 0 1.3 0.1 1.7 0.3 0.5 0.3 1.1 0.4 1.8 0.4 0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1.1-0.3 1.7-0.3 0.7 0 1.3 0.1 1.8 0.3 0.5 0.3 1.1 0.4 1.8 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m21.9 87.8c-0.7 0-1.3-0.1-1.8-0.4-0.5-0.2-1.1-0.3-1.8-0.3-0.6 0-1.3 0.1-1.7 0.3-0.5 0.3-1.1 0.4-1.8 0.4-0.7 0-1.3-0.1-1.8-0.4-0.4-0.2-1-0.3-1.7-0.3-0.7 0-1.3 0.1-1.7 0.3-0.5 0.3-1.1 0.4-1.8 0.4v1.2c0.7 0 1.3-0.2 1.8-0.4 0.4-0.3 1-0.4 1.7-0.4 0.7 0 1.3 0.1 1.7 0.4 0.5 0.2 1.1 0.4 1.8 0.4 0.7 0 1.3-0.2 1.8-0.4 0.4-0.3 1.1-0.4 1.7-0.4 0.7 0 1.3 0.1 1.8 0.4 0.5 0.2 1.1 0.4 1.8 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s10",
  d: "m21.9 90.1c-0.7 0-1.3-0.1-1.8-0.4-0.5-0.2-1.1-0.4-1.8-0.4-0.6 0-1.3 0.2-1.7 0.4-0.5 0.3-1.1 0.4-1.8 0.4-0.7 0-1.3-0.2-1.8-0.4-0.4-0.2-1-0.4-1.7-0.4-0.7 0-1.3 0.2-1.7 0.4-0.5 0.3-1.1 0.4-1.8 0.4v-1.1c0.7 0 1.3-0.2 1.8-0.4 0.4-0.3 1-0.4 1.7-0.4 0.7 0 1.3 0.1 1.7 0.4 0.5 0.2 1.1 0.4 1.8 0.4 0.7 0 1.3-0.2 1.8-0.4 0.4-0.3 1.1-0.4 1.7-0.4 0.7 0 1.3 0.1 1.8 0.4 0.5 0.2 1.1 0.4 1.8 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m21.9 91.3c-0.7 0-1.3-0.2-1.8-0.5-0.5-0.2-1.1-0.3-1.8-0.3-0.6 0-1.3 0.1-1.7 0.3-0.5 0.3-1.1 0.5-1.8 0.5-0.7 0-1.3-0.2-1.8-0.5-0.4-0.2-1-0.3-1.7-0.3-0.7 0-1.3 0.1-1.7 0.3-0.5 0.3-1.1 0.5-1.8 0.5v-1.2c0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1-0.4 1.7-0.4 0.7 0 1.3 0.2 1.7 0.4 0.5 0.2 1.1 0.4 1.8 0.4 0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1.1-0.4 1.7-0.4 0.7 0 1.3 0.2 1.8 0.4 0.5 0.3 1.1 0.4 1.8 0.4z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m10.8 80.9q0.1 0.2 0.1 0.3c0 0.7-0.6 1.2-1.3 1.2h10.4c-0.7 0-1.3-0.5-1.3-1.2q0.1-0.1 0.1-0.3-0.1 0-0.2 0h-7.6q-0.1 0-0.2 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m11 80.2h7.6c0.2 0 0.5 0.2 0.5 0.4 0 0.2-0.3 0.3-0.5 0.3h-7.6c-0.2 0-0.4-0.1-0.4-0.3 0-0.2 0.2-0.4 0.4-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m9.6 82.4h10.4v2.8h-10.4z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m8.8 70.5c-1 0.6-1.7 1.2-1.6 1.5 0.1 0.3 0.4 0.5 0.9 0.9 0.7 0.5 1.2 1.4 0.8 1.9 0.6-0.5 1-1.3 1-2.1 0-0.9-0.4-1.7-1.1-2.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_5_",
  className: "s11",
  d: "m11.1 42.2h7.4v37.6h-7.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m16.4 41.3v39.5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m17.3 41.3v39.5"
})), /*#__PURE__*/React.createElement("path", {
  id: "SVGID_5_",
  className: "s5",
  d: "m11.1 42.2h7.4v37.6h-7.4z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m26 56.3c-1.6-0.7-4.3-1.2-7.5-1.3-1 0-2.2 0.1-3.5 0.3-4.4 0.8-7.7 2.6-7.5 4.1 0 0 0 0.1 0 0.1 0 0-1.6-3.9-1.6-4-0.3-1.7 3.4-3.7 8.3-4.5 1.5-0.3 3-0.4 4.3-0.4 3.1 0 5.8 0.4 7.5 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m11.1 61c-2-0.2-3.4-0.7-3.6-1.6-0.1-0.7 0.6-1.5 1.8-2.2 0.6 0 1.2 0.1 1.8 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m18.5 58.1c1.3 0.2 2.2 0.5 2.7 1h0.1c0.2 0.5-0.9 1.6-2.8 2.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m6.5 68.2c-0.1-0.6 1.8-1.8 4.7-2.9 1.2-0.4 2.3-0.9 3.6-1.6 3.9-1.7 6.8-3.8 6.5-4.6h-0.1c0.2 0.1 0.5 3.8 0.5 3.8 0.4 0.7-2.2 2.8-5.8 4.6-1.2 0.5-3.6 1.5-4.8 1.9-2 0.7-4.1 2.1-3.9 2.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m11.1 55.7q-0.2 0.1-0.4 0.2-0.2 0-0.4 0.1l-1.1-2.8 1.2-0.5q1.1-0.4 1.4 0.3c0.3 0.7-0.3 1.1-1.2 1.5zm-0.6-1.5q0.2-0.1 0.3-0.1c0.3-0.2 0.3-0.5 0.2-0.8-0.1-0.3-0.4-0.5-0.6-0.4l-0.4 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m13.4 51.9q-0.2 0.1-0.3 0.1-0.2 0.1-0.4 0.1l0.6 2.9 2-0.4q-0.1-0.1-0.1-0.2 0 0 0-0.1-0.5 0.1-1.2 0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m17.4 54.5c0.4-1.1 0.8-2.1 1.3-3.2q-0.1 0.1-0.3 0.1-0.1 0-0.2 0-0.4 1.1-0.8 2.2c-0.4-0.7-0.8-1.4-1.1-2.1q-0.3 0-0.5 0.1-0.3 0-0.5 0 0.9 1.4 1.7 2.9 0.1 0 0.2 0 0.1 0 0.2 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m21.6 52.2q0.1-0.2 0.2-0.4c-0.1-0.1-0.5-0.3-0.8-0.3-0.9-0.1-1.3 0.3-1.4 0.8-0.1 1 1.5 1 1.5 1.7-0.1 0.3-0.4 0.4-0.7 0.4-0.4-0.1-0.7-0.3-0.7-0.6h-0.1q-0.1 0.3-0.2 0.5c0.2 0.2 0.5 0.3 0.8 0.3 0.8 0.1 1.5-0.3 1.5-0.8 0.1-1-1.5-1.1-1.4-1.7 0-0.2 0.2-0.4 0.6-0.4 0.3 0.1 0.5 0.2 0.6 0.5z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m82.3 33.6c0 0-0.3 0.4-0.5 0.5-0.3 0-0.6-0.3-0.6-0.3 0 0-0.2 0.3-0.5 0.3-0.2 0.1-0.6-0.3-0.6-0.3 0 0-0.3 0.4-0.5 0.5-0.2 0.1-0.5-0.1-0.5-0.1 0 0-0.1 0.2-0.3 0.3-0.1 0-0.2-0.1-0.2-0.1l-0.3-0.1-0.3-0.4-0.3-0.1c0 0-0.1-0.4-0.1-0.5 0-0.1-0.1-0.3-0.1-0.3 0-0.3 0.4-0.6 1.1-0.8q0.6-0.1 0.9 0c0.3-0.2 0.8-0.4 1.5-0.4 0.6 0 1.1 0.2 1.3 0.4 0.3-0.2 0.8-0.4 1.4-0.4 0.7 0 1.2 0.2 1.5 0.4q0.3-0.1 0.9 0c0.6 0.2 1.1 0.5 1 0.8 0 0 0 0.2 0 0.3 0 0.1-0.1 0.5-0.1 0.5l-0.3 0.1-0.3 0.4-0.3 0.1c0 0-0.1 0.1-0.2 0.1-0.2-0.1-0.3-0.3-0.3-0.3 0 0-0.3 0.2-0.5 0.1-0.2-0.1-0.5-0.5-0.5-0.5 0 0-0.4 0.4-0.6 0.3-0.3 0-0.5-0.3-0.5-0.3 0 0-0.3 0.3-0.6 0.3-0.2-0.1-0.6-0.5-0.6-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m82.3 32.6c-0.3 0-0.6-0.4-0.6-0.9 0-0.6 0.3-1 0.6-1 0.4 0 0.7 0.4 0.7 1 0 0.5-0.3 0.9-0.7 0.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m82.3 32.5c-0.1 0-0.2-0.4-0.2-0.9 0-0.4 0.1-0.8 0.2-0.8 0.2 0 0.3 0.4 0.3 0.8 0 0.5-0.1 0.9-0.3 0.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m79.1 35.4c-0.1-0.2-0.2-0.5-0.2-0.5 0.9-0.2 2.1-0.4 3.4-0.4 1.4 0 2.6 0.2 3.5 0.4 0 0-0.1 0.2-0.2 0.5-0.1 0.1-0.2 0.3-0.2 0.3q-1.2-0.3-3.1-0.3c-1.2 0-2.4 0.1-3.1 0.4 0 0 0-0.2-0.1-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m82.3 36.6c1.1 0 2.4-0.2 2.8-0.3 0.3-0.1 0.5-0.2 0.4-0.4q0-0.1-0.1-0.2c-0.7-0.2-1.9-0.3-3.1-0.3-1.2 0-2.3 0.1-3 0.3q-0.1 0.1-0.2 0.2c0 0.2 0.2 0.3 0.5 0.4 0.4 0.1 1.6 0.3 2.7 0.3z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m85.2 32.3c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.2 0.2-0.2 0.1 0 0.2 0 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m85.1 31.6c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.2 0.2-0.2 0.1 0 0.2 0 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m84.6 31.1c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m84 30.9c-0.2 0-0.3-0.1-0.3-0.2 0-0.1 0.1-0.2 0.3-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m83.3 30.9c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s12",
  d: "m87 33.4q0.1-0.2 0.1-0.5c0-0.7-0.5-1.3-1.2-1.3q-0.4 0-0.7 0.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m84.8 32.5q0.1-0.2 0.1-0.4c0-0.6-0.6-1-1.2-1q-0.5 0-0.8 0.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m87.4 33c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m87.3 32.3c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.2 0 0.2 0.1 0.2 0.2 0 0.1 0 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m86.9 31.7c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m86.3 31.4c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m85.6 31.4c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m85.9 34.4l-0.3-0.2c0 0-0.2 0.1-0.6 0.1-0.3-0.1-0.4-0.5-0.4-0.5 0 0-0.3 0.3-0.6 0.3-0.3 0-0.5-0.3-0.5-0.3 0 0-0.3 0.3-0.6 0.2-0.3 0-0.6-0.3-0.6-0.3 0 0-0.3 0.3-0.5 0.4-0.3 0-0.6-0.3-0.6-0.3 0 0-0.1 0.3-0.4 0.3-0.4 0.1-0.7-0.2-0.7-0.2 0 0-0.2 0.3-0.5 0.4-0.2 0.1-0.5-0.1-0.5-0.1 0 0-0.1 0.1-0.1 0.2 0 0-0.1 0-0.1 0v0.3c0.9-0.3 2.1-0.5 3.4-0.5 1.4 0 2.6 0.2 3.5 0.5z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m79.4 32.3c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.2 0.2-0.2 0.2 0 0.2 0 0.2 0.2 0 0.1 0 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m79.6 31.6c-0.2 0-0.2-0.1-0.2-0.2 0-0.2 0-0.2 0.2-0.2 0.1 0 0.2 0 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m80.1 31.1c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m80.7 30.9c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m81.4 30.9c-0.2 0-0.2-0.1-0.2-0.2 0-0.1 0-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s12",
  d: "m77.6 33.4q-0.1-0.2-0.1-0.5c0-0.7 0.6-1.3 1.3-1.3q0.3 0 0.6 0.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m79.9 32.5q-0.1-0.2-0.1-0.4c0-0.6 0.5-1 1.2-1q0.4 0 0.7 0.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m77.2 33c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.2 0 0.2 0.1 0.2 0.2 0 0.1 0 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m77.3 32.3c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m77.8 31.7c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m78.4 31.4c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m79 31.4c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.2 0 0.2 0.1 0.2 0.2 0 0.1 0 0.2-0.2 0.2z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m82.3 33.2h0.2q-0.1 0.1 0 0.2c0 0.3 0.2 0.5 0.5 0.5 0.2 0 0.4-0.1 0.4-0.3 0 0 0.1-0.2 0.1-0.2 0 0 0 0.2 0 0.2 0.1 0.2 0.3 0.4 0.5 0.4 0.3 0 0.5-0.2 0.5-0.5q0 0 0-0.1l0.2-0.1 0.1 0.2q-0.1 0.1-0.1 0.2c0 0.3 0.2 0.5 0.5 0.5q0.3 0 0.4-0.2l0.1-0.2v0.2c0 0.1 0.1 0.3 0.2 0.3 0 0 0.2 0 0.4-0.2 0.3-0.2 0.4-0.3 0.4-0.3v0.2c0 0-0.2 0.4-0.4 0.5-0.1 0.1-0.3 0.2-0.5 0.1-0.1 0-0.2-0.1-0.3-0.3q-0.1 0.1-0.3 0.1c-0.3 0-0.6-0.1-0.7-0.4q-0.2 0.3-0.5 0.3c-0.2 0-0.4-0.1-0.6-0.3q-0.2 0.2-0.4 0.2c-0.3 0-0.5-0.1-0.7-0.3-0.1 0.2-0.3 0.3-0.6 0.3q-0.3 0-0.5-0.2c-0.1 0.2-0.3 0.3-0.5 0.3q-0.3 0-0.5-0.3c-0.1 0.3-0.4 0.4-0.7 0.4q-0.2 0-0.3-0.1c-0.1 0.2-0.2 0.3-0.4 0.3-0.1 0.1-0.3 0-0.4-0.1-0.2-0.1-0.4-0.5-0.4-0.5v-0.2c0 0 0.1 0.1 0.4 0.3 0.2 0.2 0.4 0.2 0.4 0.2 0.1 0 0.2-0.2 0.2-0.3v-0.2l0.1 0.2q0.1 0.2 0.4 0.2c0.3 0 0.5-0.2 0.5-0.5q0-0.1-0.1-0.2l0.1-0.2 0.2 0.1q0 0.1 0 0.1c0 0.3 0.2 0.5 0.5 0.5 0.2 0 0.4-0.2 0.5-0.4 0 0 0-0.2 0-0.2 0 0 0 0.2 0.1 0.2 0 0.2 0.2 0.3 0.4 0.3 0.3 0 0.5-0.2 0.5-0.5q0-0.1 0-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m82.3 34.5c-1.3 0-2.5 0.2-3.4 0.4-0.1 0.1-0.2 0-0.2 0 0-0.1 0-0.2 0.1-0.2 0.9-0.3 2.1-0.5 3.5-0.5 1.4 0 2.7 0.2 3.6 0.5 0 0 0.1 0.1 0.1 0.2 0 0-0.1 0.1-0.2 0-0.9-0.2-2.1-0.4-3.5-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m81.2 35.2c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m82.4 35.1h-0.5c-0.1 0-0.1-0.1-0.1-0.2 0 0 0-0.1 0.1-0.1h0.5 0.4c0.1 0 0.2 0.1 0.2 0.1 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m80.2 35.2l-0.4 0.1c0 0-0.1-0.1-0.1-0.1 0-0.1 0-0.2 0.1-0.2h0.3l0.3-0.1c0.1 0 0.2 0 0.2 0.1 0 0.1 0 0.2-0.1 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m78.9 35.5l0.1-0.3 0.3 0.1-0.1 0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m83.5 35.2c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m84.5 35.2l0.3 0.1c0.1 0 0.2-0.1 0.2-0.1 0-0.1 0-0.2-0.1-0.2h-0.3l-0.3-0.1c-0.1 0-0.2 0-0.2 0.1 0 0.1 0 0.2 0.1 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m85.8 35.5l-0.1-0.3-0.3 0.1 0.1 0.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_7_",
  fillRule: "evenodd",
  className: "s8",
  d: "m82.3 36.3c-1.1 0-2.1-0.1-2.8-0.3 0.7-0.2 1.7-0.3 2.8-0.3 1.1 0 2.1 0.1 2.9 0.3-0.8 0.2-1.8 0.3-2.9 0.3z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m83.2 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m82.8 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m82.4 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m82 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m81.7 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m81.4 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m81.1 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m80.8 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m80.5 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m80.2 35.1v1.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m79.9 35.1v1.8"
}))), /*#__PURE__*/React.createElement("path", {
  id: "SVGID_7_",
  fillRule: "evenodd",
  className: "s5",
  d: "m82.3 36.3c-1.1 0-2.1-0.1-2.8-0.3 0.7-0.2 1.7-0.3 2.8-0.3 1.1 0 2.1 0.1 2.9 0.3-0.8 0.2-1.8 0.3-2.9 0.3z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m85.7 34c-0.1 0-0.1-0.1-0.1-0.2 0-0.1 0.1-0.2 0.2-0.1 0 0 0 0.1 0 0.2 0 0-0.1 0.1-0.1 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m83.5 33.6c-0.1 0-0.1-0.1-0.1-0.2 0-0.1 0.1-0.2 0.1-0.2 0.1 0 0.1 0.1 0.1 0.2 0 0.1-0.1 0.2-0.1 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m81.2 33.2c0 0 0.1 0.1 0.1 0.2 0 0.1 0 0.2-0.1 0.2-0.1 0-0.1-0.1-0.1-0.2 0-0.1 0-0.2 0.1-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m78.9 33.7c0.1-0.1 0.2 0 0.2 0.1 0 0.1 0 0.2-0.1 0.2 0 0-0.1-0.1-0.1-0.1 0-0.1 0-0.2 0-0.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m82.3 32.1l-0.3 0.2 0.2 0.7 0.1 0.1 0.1-0.1 0.3-0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m81.5 33.1l0.2 0.2 0.6-0.1v-0.1-0.1l-0.6-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m83.2 33.1l-0.2 0.2-0.6-0.1-0.1-0.1 0.1-0.1 0.6-0.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m79.8 32.4l-0.3 0.3 0.4 0.5 0.1 0.1 0.1-0.1 0.1-0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m79.2 33.5l0.2 0.2 0.6-0.3v-0.1l-0.1-0.1-0.6-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m80.8 33.1l-0.1 0.3-0.6-0.1h-0.1l0.1-0.1 0.5-0.3z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m78.6 33.5l-0.1 0.4h-0.6-0.1v-0.1l0.5-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m80 33.5c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.2 0.2-0.2 0.1 0 0.2 0 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m84.9 32.4l0.3 0.3-0.4 0.5-0.1 0.1-0.1-0.1-0.1-0.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m85.5 33.5l-0.2 0.2-0.6-0.3v-0.1l0.1-0.1 0.6-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m83.8 33.1l0.2 0.3 0.6-0.1h0.1l-0.1-0.1-0.5-0.3z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m86 33.5l0.1 0.4h0.6 0.1v-0.1l-0.5-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m82.3 33.3c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.3 0.2-0.3 0.2 0 0.3 0.1 0.3 0.3 0 0.1-0.1 0.2-0.3 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m84.7 33.5c-0.1 0-0.2-0.1-0.2-0.2 0-0.2 0.1-0.2 0.2-0.2 0.1 0 0.2 0 0.2 0.2 0 0.1-0.1 0.2-0.2 0.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s4",
  d: "m82.3 31c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.4 0.4-0.4 0.3 0 0.5 0.2 0.5 0.4 0 0.2-0.2 0.4-0.5 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m82.6 30.4v0.3h-0.6v-0.3h0.2v-0.6h-0.3v-0.2h0.3v-0.3h0.3v0.3h0.3v0.2h-0.3v0.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m82.9 30.4v0.3h-1.1v-0.3h0.4v-0.6h-0.3v-0.2h0.3v-0.3h0.3v0.3h0.3v0.2h-0.3v0.6z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m82.3 31c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.4 0.4-0.4 0.3 0 0.5 0.2 0.5 0.4 0 0.2-0.2 0.4-0.5 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s0",
  d: "m82.3 31c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.4 0.4-0.4 0.3 0 0.5 0.2 0.5 0.4 0 0.2-0.2 0.4-0.5 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m82.5 30.2c0.1 0 0.3 0.2 0.3 0.4 0 0.2-0.2 0.4-0.5 0.4-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.4 0.3-0.4"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m77.7 33.9c0 0-0.2-0.2-0.3-0.3-0.1-0.1-0.3-0.2-0.3-0.2 0 0 0.1-0.1 0.3-0.1q0.1 0 0.2 0.1v-0.1c0 0 0.1 0 0.2 0.1 0 0.2 0 0.4 0 0.4 0 0-0.1 0.1-0.1 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m78 33.8c0 0.1 0.1 0.2 0 0.3 0 0-0.1 0-0.2-0.1-0.1 0-0.1-0.2-0.1-0.2 0.1-0.1 0.2-0.1 0.3 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m86.9 33.9c0 0 0.2-0.2 0.3-0.3 0.1-0.1 0.3-0.2 0.3-0.2 0 0-0.1-0.1-0.3-0.1q-0.1 0-0.2 0.1v-0.1c0 0-0.1 0-0.1 0.1-0.1 0.2-0.1 0.4-0.1 0.4 0 0 0.1 0.1 0.1 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m86.9 34c-0.1 0.1-0.2 0.1-0.3 0.1 0-0.1 0-0.2 0.1-0.3 0-0.1 0.2-0.1 0.2 0 0.1 0 0 0.2 0 0.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m77.3 36.5h10.1v2.8h-10.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m86.3 41.1q0 0-0.1 0h-7.6q-0.1 0-0.2 0c0.2-0.1 0.4-0.3 0.4-0.6 0-0.3-0.2-0.6-0.4-0.6q0.1 0 0.2 0h7.5q0.2 0 0.3 0h-0.1c-0.3 0.1-0.4 0.3-0.4 0.6 0 0.2 0.2 0.5 0.4 0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m78.6 41.1h7.6c0.2 0 0.4 0.1 0.4 0.3 0 0.2-0.2 0.4-0.4 0.4h-7.6c-0.3 0-0.5-0.2-0.5-0.4 0-0.2 0.2-0.3 0.5-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m78.6 39.3h7.6c0.2 0 0.4 0.1 0.4 0.3 0 0.2-0.2 0.3-0.4 0.3h-7.6c-0.3 0-0.5-0.1-0.5-0.3 0-0.2 0.2-0.3 0.5-0.3z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m75.3 85.6c0.7 0 1.3-0.2 1.8-0.4 0.4-0.3 1.1-0.4 1.7-0.4 0.7 0 1.3 0.1 1.8 0.4 0.5 0.2 1.1 0.4 1.8 0.4 0.7 0 1.3-0.2 1.8-0.4 0.4-0.3 1-0.4 1.7-0.4 0.7 0 1.3 0.1 1.7 0.4 0.5 0.2 1.1 0.4 1.8 0.4v1.1c-0.7 0-1.3-0.1-1.8-0.4-0.4-0.2-1-0.4-1.7-0.4-0.7 0-1.3 0.2-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4-0.7 0-1.3-0.1-1.8-0.4-0.5-0.2-1.1-0.4-1.8-0.4-0.6 0-1.3 0.2-1.7 0.4-0.5 0.3-1.1 0.4-1.8 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s10",
  d: "m75.3 86.7c0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1.1-0.4 1.7-0.4 0.7 0 1.3 0.2 1.8 0.4 0.5 0.3 1.1 0.4 1.8 0.4 0.7 0 1.3-0.2 1.8-0.4 0.4-0.2 1-0.4 1.7-0.4 0.7 0 1.3 0.2 1.7 0.4 0.5 0.2 1.1 0.4 1.8 0.4v1.1c-0.7 0-1.3-0.1-1.8-0.4-0.4-0.2-1-0.3-1.7-0.3-0.7 0-1.3 0.1-1.7 0.3-0.5 0.3-1.1 0.4-1.8 0.4-0.7 0-1.3-0.1-1.8-0.4-0.5-0.2-1.1-0.3-1.8-0.3-0.6 0-1.3 0.1-1.7 0.3-0.5 0.3-1.1 0.4-1.8 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m75.3 87.8c0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1.1-0.3 1.7-0.3 0.7 0 1.3 0.1 1.8 0.3 0.5 0.3 1.1 0.4 1.8 0.4 0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1-0.3 1.7-0.3 0.7 0 1.3 0.1 1.7 0.3 0.5 0.3 1.1 0.4 1.8 0.4v1.2c-0.7 0-1.3-0.2-1.8-0.4-0.4-0.3-1-0.4-1.7-0.4-0.7 0-1.3 0.1-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4-0.7 0-1.3-0.2-1.8-0.4-0.5-0.3-1.1-0.4-1.8-0.4-0.6 0-1.3 0.1-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s10",
  d: "m75.3 90.1c0.7 0 1.3-0.1 1.8-0.4 0.4-0.2 1.1-0.4 1.7-0.4 0.7 0 1.3 0.2 1.8 0.4 0.5 0.3 1.1 0.4 1.8 0.4 0.7 0 1.3-0.2 1.8-0.4 0.4-0.2 1-0.4 1.7-0.4 0.7 0 1.3 0.2 1.7 0.4 0.5 0.3 1.1 0.4 1.8 0.4v-1.1c-0.7 0-1.3-0.2-1.8-0.4-0.4-0.3-1-0.4-1.7-0.4-0.7 0-1.3 0.1-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4-0.7 0-1.3-0.2-1.8-0.4-0.5-0.3-1.1-0.4-1.8-0.4-0.6 0-1.3 0.1-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m75.3 91.3c0.7 0 1.3-0.2 1.8-0.5 0.4-0.2 1.1-0.3 1.7-0.3 0.7 0 1.3 0.1 1.8 0.3 0.5 0.3 1.1 0.5 1.8 0.5 0.7 0 1.3-0.2 1.8-0.5 0.4-0.2 1-0.3 1.7-0.3 0.7 0 1.3 0.1 1.7 0.3 0.5 0.3 1.1 0.5 1.8 0.5v-1.2c-0.7 0-1.3-0.1-1.8-0.4-0.4-0.2-1-0.4-1.7-0.4-0.7 0-1.3 0.2-1.7 0.4-0.5 0.2-1.1 0.4-1.8 0.4-0.7 0-1.3-0.1-1.8-0.4-0.5-0.2-1.1-0.4-1.8-0.4-0.6 0-1.3 0.2-1.7 0.4-0.5 0.3-1.1 0.4-1.8 0.4z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m86.3 80.9q0 0.2 0 0.3c0 0.7 0.6 1.2 1.3 1.2h-10.4c0.7 0 1.2-0.5 1.2-1.2q0-0.1 0-0.3 0.1 0 0.2 0h7.6q0 0 0.1 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m78.6 80.2h7.6c0.2 0 0.4 0.2 0.4 0.4 0 0.2-0.2 0.3-0.4 0.3h-7.6c-0.3 0-0.5-0.1-0.5-0.3 0-0.2 0.2-0.4 0.5-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m77.2 82.4h10.3v2.8h-10.3z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m88.3 70.5c1.1 0.6 1.8 1.2 1.7 1.5-0.1 0.3-0.4 0.5-0.9 0.9-0.7 0.5-1.2 1.4-0.8 1.9-0.6-0.5-1-1.3-1-2.1 0-0.9 0.4-1.7 1-2.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_11_",
  className: "s11",
  d: "m78.7 42.2h7.4v37.6h-7.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m84 41.3v39.5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m84.9 41.3v39.5"
})), /*#__PURE__*/React.createElement("path", {
  id: "SVGID_11_",
  className: "s5",
  d: "m78.7 42.2h7.4v37.6h-7.4z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m71.2 56.3c1.6-0.7 4.3-1.2 7.4-1.3 1.1 0 2.3 0.1 3.6 0.3 4.4 0.8 7.7 2.6 7.5 4.1 0 0-0.1 0.1-0.1 0.1 0 0 1.7-3.9 1.7-4 0.3-1.7-3.4-3.7-8.3-4.5-1.5-0.3-3-0.4-4.3-0.4-3.1 0-5.9 0.4-7.5 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m86.1 61c2-0.2 3.4-0.7 3.6-1.6 0.1-0.7-0.6-1.5-1.8-2.2-0.6 0-1.2 0.1-1.8 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m78.7 58.1c-1.3 0.2-2.3 0.5-2.7 1h-0.1c-0.2 0.5 0.9 1.6 2.8 2.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m90.6 68.2c0.2-0.6-1.8-1.8-4.6-2.9-1.3-0.4-2.3-0.9-3.6-1.6-3.9-1.7-6.8-3.8-6.5-4.6h0.1c-0.2 0.1-0.6 3.8-0.6 3.8-0.3 0.7 2.3 2.8 5.9 4.6 1.2 0.5 3.6 1.5 4.7 1.9 2.1 0.7 4.1 2.1 4 2.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m75.7 54.7c0.3-1.1 0.7-2.2 1-3.3q-0.1 0.1-0.2 0.1-0.1 0-0.3 0-0.2 1.2-0.6 2.3c-0.4-0.6-0.9-1.3-1.3-2q-0.2 0.1-0.4 0.1-0.3 0-0.5 0 1 1.4 1.9 2.8 0.1 0 0.2 0 0.1 0 0.2 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m78.5 51.5q-0.2 0-0.4 0-0.2 0-0.4-0.1v3.1h2q0-0.1 0-0.2 0-0.1 0-0.2-0.5 0.1-1.2 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m81.7 51.9q0.5 0.1 1 0.2 0-0.1 0-0.2 0-0.1 0-0.2l-2.7-0.2q0 0.1 0 0.2 0 0.1-0.1 0.2 0.5-0.1 1 0l-0.2 2.7q0.2 0 0.4 0 0.2 0 0.4 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m83.5 52l1.2 0.2c0.2 0.1 0.6 0.1 0.8 0.3q0.4 0.3 0.3 0.7c-0.1 0.4-0.5 0.6-1 0.6q0.3 0.7 0.6 1.4l0.2 0.3q-0.3 0-0.5-0.1-0.2 0-0.5-0.1l-0.4-1c0-0.2-0.1-0.4-0.2-0.6l-0.4 1.4q-0.2-0.1-0.4-0.1-0.2 0-0.4-0.1zm0.5 1.6q0.8 0.2 1-0.4 0-0.1 0-0.3c0-0.3-0.4-0.4-0.7-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s4",
  d: "m87 55.2c-0.3 0.2-0.5 0.4-0.8 0.6q-0.1 0-0.2-0.1-0.1-0.1-0.2-0.1l2.9-1.9q0 0 0.1 0.1 0.1 0 0.2 0.1l-0.3 3.4q-0.2-0.2-0.3-0.3-0.3-0.1-0.5-0.2 0.1-0.5 0.2-1zm1.1 0.3l0.1-1.1-1 0.7z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m38.2 25.2c-0.5 0-1-0.4-1-1 0-0.5 0.5-0.9 1-0.9 0.6 0 1 0.4 1 0.9 0 0.6-0.4 1-1 1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_13_",
  fillRule: "evenodd",
  className: "s8",
  d: "m48.3 15.9c3 0 5.7 0.4 7.4 1.2 1 0.4 2.4 0.8 3.8 1 1.2 0.1 2.2 0.2 3.1 0.1 1.3 0 3.1 0.3 4.8 1.2 1.5 0.6 2.8 1.5 3.6 2.3l-0.7 0.6-0.2 1.9-2 2.3-1 0.9-2.3 1.9-1.1 0.1-0.4 1.1-14.9-1.9-14.9 1.9-0.4-1.1-1.2-0.1-2.3-1.9-1-0.9-1.9-2.3-0.2-1.9-0.7-0.6c0.8-0.8 2-1.7 3.5-2.3 1.8-0.9 3.6-1.2 4.8-1.2 0.9 0.1 2 0 3.1-0.1 1.5-0.2 2.8-0.6 3.8-1 1.8-0.8 4.3-1.2 7.3-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "SVGID_13_",
  fillRule: "evenodd",
  className: "s5",
  d: "m48.3 15.9c3 0 5.7 0.4 7.4 1.2 1 0.4 2.4 0.8 3.8 1 1.2 0.1 2.2 0.2 3.1 0.1 1.3 0 3.1 0.3 4.8 1.2 1.5 0.6 2.8 1.5 3.6 2.3l-0.7 0.6-0.2 1.9-2 2.3-1 0.9-2.3 1.9-1.1 0.1-0.4 1.1-14.9-1.9-14.9 1.9-0.4-1.1-1.2-0.1-2.3-1.9-1-0.9-1.9-2.3-0.2-1.9-0.7-0.6c0.8-0.8 2-1.7 3.5-2.3 1.8-0.9 3.6-1.2 4.8-1.2 0.9 0.1 2 0 3.1-0.1 1.5-0.2 2.8-0.6 3.8-1 1.8-0.8 4.3-1.2 7.3-1.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m48.5 31.6c-5.6 0-10.7 0.7-14.2 1.9 0.3-0.2 0.2-0.5-0.1-1.5-0.5-1.2-1.2-1.2-1.2-1.2 4-1.2 9.4-1.9 15.5-1.9 6.1 0 11.6 0.7 15.5 1.9 0 0-0.7 0-1.1 1.2-0.4 1-0.4 1.3-0.1 1.5-3.6-1.2-8.7-1.9-14.3-1.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m48.5 28.9c-6.1 0-11.5 0.7-15.5 1.9-0.2 0.1-0.5 0-0.6-0.2-0.1-0.3 0.1-0.6 0.3-0.7 4-1.2 9.6-2 15.8-2 6.2 0 11.9 0.8 15.8 2 0.3 0.1 0.4 0.4 0.3 0.7-0.1 0.2-0.3 0.3-0.6 0.2-3.9-1.2-9.4-1.9-15.5-1.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m48.5 36.4c-5.5-0.1-10.5-0.7-14-1.9-0.3 0-0.4-0.3-0.4-0.5 0-0.3 0.1-0.5 0.4-0.6 3.5-1.1 8.5-1.8 14-1.8 5.6 0 10.5 0.7 14.1 1.8 0.3 0.1 0.4 0.3 0.4 0.6 0 0.2-0.1 0.5-0.4 0.5-3.5 1.2-8.5 1.8-14.1 1.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_15_",
  fillRule: "evenodd",
  className: "s8",
  d: "m48.5 35.6c-5 0-9.5-0.6-13-1.5 3.5-1 8-1.5 13-1.5 5 0 9.6 0.5 13 1.5-3.4 0.9-8 1.5-13 1.5z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp9)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m48.6 31.9v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m47.8 31.9v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m47.1 31.9v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m46.3 31.9v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m45.7 31.9v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m45 31.9v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m44.4 31.9v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m43.8 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m43.3 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m42.7 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m42.2 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m41.7 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m41.2 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m40.6 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m40.1 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m39.6 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m39 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m38.4 31.8v6.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m37.9 31.8v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s13",
  d: "m37.3 31.8v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s13",
  d: "m36.8 31.8v6.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s14",
  d: "m36.2 31.8v6.2"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp10)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m49.4 31.9v6.2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp11)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m50.4 31.9v6.2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp12)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m51.7 31.9v6.2"
})), /*#__PURE__*/React.createElement("path", {
  id: "SVGID_15_",
  fillRule: "evenodd",
  className: "s5",
  d: "m48.5 35.6c-5 0-9.5-0.6-13-1.5 3.5-1 8-1.5 13-1.5 5 0 9.6 0.5 13 1.5-3.4 0.9-8 1.5-13 1.5z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m44.7 30.8c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.5 0.2 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m48.5 30.7h-1.5c-0.2 0-0.5-0.2-0.5-0.5 0-0.3 0.3-0.5 0.5-0.5h1.5 1.5c0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m41.1 31.1l-1.1 0.1c-0.3 0.1-0.5-0.1-0.6-0.4 0-0.2 0.2-0.5 0.5-0.5l1-0.2 1.1-0.1c0.3 0 0.5 0.2 0.6 0.4 0 0.3-0.2 0.6-0.5 0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m37.2 31.7c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m33.4 32.1l0.5-0.7 1.6 0.2-1.2 0.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m56 31.1l1.1 0.1c0.2 0.1 0.5-0.1 0.5-0.4 0.1-0.2-0.1-0.5-0.4-0.5l-1.1-0.2-1.1-0.1c-0.2 0-0.5 0.2-0.5 0.4-0.1 0.3 0.1 0.6 0.4 0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m52.4 30.8c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m59.9 31.7c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.5 0.2 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m63.7 32.1l-0.6-0.7-1.5 0.2 1.2 0.9z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m34.9 34.2c3.5-1 8.3-1.6 13.6-1.6 5.3 0 10.1 0.6 13.6 1.6"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m37.3 20l0.6 0.5 1-1.6c-1.1-0.7-1.8-1.8-1.8-3.1q0-0.2 0.1-0.4c0.1-2 2.5-3.7 5.5-3.7 1.6 0 3 0.4 4 1.1 0-0.3 0-0.5 0.1-0.8-1.1-0.7-2.5-1.1-4.1-1.1-3.5 0-6.2 2.1-6.4 4.5q0 0.2 0 0.4c0 1.3 0.6 2.5 1.5 3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m37.3 20c-1.2-0.9-1.9-2.2-1.9-3.6 0-1.6 1-3 2.5-3.9-0.9 0.8-1.5 1.8-1.6 2.9q0 0.2 0 0.4c0 1.3 0.6 2.5 1.5 3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m26.8 21.6c-0.6-0.8-1.1-1.8-1.1-2.9q0.1-1 0.5-1.8c0.9-2.1 3.9-3.6 7.5-3.6q1.5 0 2.8 0.3-0.3 0.3-0.5 0.7-1-0.2-2.3-0.2c-3.2 0-6 1.3-6.8 3.1q-0.3 0.7-0.3 1.5c0 1.1 0.5 2.1 1.2 2.8l-1.2 2-0.6-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m28 14.8c-0.8 0.6-1.5 1.3-1.8 2.1q-0.4 0.8-0.5 1.8c0 1.1 0.5 2.1 1.1 2.9l-0.7 1.2c-0.7-0.9-1.1-2-1.1-3.1 0-2 1.2-3.7 3-4.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m48.5 10.5c0.8 0 1.5 0.5 1.6 1.3q0.2 1 0.2 2.1 0 0.2 0 0.3 0 0.1 0 0.3c0.1 1.6 0.3 3.1 0.6 4l-2.4 2.4-2.5-2.4c0.3-0.9 0.6-2.4 0.6-4q0-0.2 0-0.3 0-0.1 0-0.3 0-1.1 0.2-2.1c0.2-0.8 0.9-1.3 1.7-1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m48.5 11.3c0.4 0 0.7 0.2 0.8 0.6q0.2 1 0.2 2.1 0 0.1 0 0.2 0 0.2 0 0.3c0 1.6 0.3 2.9 0.6 3.8l-1.6 1.6-1.6-1.6c0.3-0.9 0.5-2.2 0.5-3.8q0-0.1 0-0.3 0-0.1 0-0.2 0-1.1 0.2-2.1c0.1-0.4 0.5-0.6 0.9-0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m59.6 20l-0.6 0.5-0.9-1.6c1-0.7 1.7-1.8 1.7-3.1q0-0.2 0-0.4c-0.1-2-2.5-3.7-5.6-3.7-1.5 0-3 0.4-4 1.1 0-0.3 0-0.5-0.1-0.8 1.2-0.7 2.6-1.1 4.1-1.1 3.5 0 6.3 2.1 6.4 4.5q0 0.2 0 0.4c0 1.3-0.6 2.5-1.5 3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m59.6 20c1.2-0.9 1.9-2.2 1.9-3.6 0-1.6-1-3-2.5-3.9 0.9 0.8 1.5 1.8 1.6 2.9q0 0.2 0 0.4c0 1.3-0.6 2.5-1.5 3.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m70.1 21.6c0.7-0.8 1.1-1.8 1.1-2.9q0-1-0.4-1.8c-1-2.1-4-3.6-7.6-3.6q-1.5 0-2.8 0.3 0.3 0.3 0.5 0.7 1.1-0.2 2.3-0.2c3.3 0 6 1.3 6.8 3.1q0.4 0.7 0.4 1.5c0 1.1-0.5 2.1-1.3 2.8l1.2 2 0.6-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m68.9 14.8c0.9 0.6 1.5 1.3 1.9 2.1q0.4 0.8 0.4 1.8c0 1.1-0.4 2.1-1.1 2.9l0.7 1.2c0.7-0.9 1.1-2 1.1-3.1 0-2-1.2-3.7-3-4.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: "m48.6 17.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m48.5 19.7c-0.5 0-0.9-0.4-0.9-0.9 0-0.5 0.4-0.8 0.9-0.8 0.5 0 0.8 0.3 0.8 0.8 0 0.5-0.3 0.9-0.8 0.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m48.5 18c-0.5 0-0.9-0.4-0.9-0.9 0-0.4 0.4-0.8 0.9-0.8 0.5 0 0.8 0.4 0.8 0.8 0 0.5-0.3 0.9-0.8 0.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m48.5 16c-0.4 0-0.7-0.3-0.7-0.6 0-0.4 0.3-0.7 0.7-0.7 0.4 0 0.7 0.3 0.7 0.7 0 0.3-0.3 0.6-0.7 0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m48.5 14.2c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m48.5 12.7c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.4 0.4-0.4 0.2 0 0.4 0.2 0.4 0.4 0 0.2-0.2 0.4-0.4 0.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m48.5 23.9l0.6 0.1q-0.1 0.4-0.1 0.8c0 1.2 1 2.2 2.2 2.2 1 0 1.9-0.7 2.1-1.5 0.1 0 0.3-0.8 0.4-0.8 0 0 0 0.8 0.1 0.8 0.1 1.1 1.1 1.9 2.2 1.9 1.2 0 2.2-1 2.2-2.2q0-0.2 0-0.3l0.7-0.7 0.3 0.9q-0.2 0.4-0.2 1c0 1.1 1 2.1 2.2 2.1 0.7 0 1.3-0.4 1.7-1l0.5-0.6v0.8c0 0.7 0.3 1.3 0.9 1.5 0 0 0.8 0 1.9-0.8 1-0.9 1.6-1.6 1.6-1.6l0.1 0.9c0 0-0.9 1.3-1.8 1.9-0.6 0.3-1.3 0.6-2 0.5-0.6-0.1-1.1-0.6-1.3-1.2-0.5 0.2-1 0.4-1.6 0.4-1.3 0-2.4-0.7-2.9-1.8-0.6 0.6-1.4 1-2.3 1-1.1 0-2-0.4-2.6-1.2-0.5 0.6-1.3 0.9-2.2 0.9-1.1 0-2.1-0.5-2.7-1.4-0.5 0.8-1.5 1.4-2.6 1.4-0.9 0-1.7-0.3-2.3-0.9-0.5 0.8-1.5 1.2-2.5 1.2-0.9 0-1.8-0.4-2.3-1-0.5 1.1-1.6 1.8-2.9 1.8-0.6 0-1.1-0.2-1.6-0.4-0.2 0.6-0.7 1.1-1.4 1.2-0.6 0.1-1.4-0.2-1.9-0.5-0.9-0.6-1.8-1.9-1.8-1.9l0.1-0.9c0 0 0.6 0.7 1.6 1.6 1.1 0.8 1.8 0.8 1.8 0.8 0.7-0.2 1-0.8 1-1.5v-0.8l0.5 0.6c0.3 0.6 1 1 1.7 1 1.2 0 2.2-1 2.2-2.1q0-0.6-0.3-1l0.4-0.9 0.7 0.7q0 0.1 0 0.3c0 1.2 1 2.2 2.2 2.2 1.1 0 2.1-0.8 2.2-1.9 0.1 0 0.1-0.8 0.1-0.8 0.1 0 0.3 0.8 0.3 0.8 0.3 0.8 1.2 1.5 2.2 1.5 1.2 0 2.2-1 2.2-2.2q0-0.4-0.1-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s6",
  d: "m63.8 26.8c0.2-0.4 0-0.8-0.2-0.9-0.3-0.1-0.6 0.2-0.8 0.6-0.1 0.4 0 0.8 0.3 0.9 0.3 0 0.6-0.2 0.7-0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m53.6 25.5c-0.3 0-0.5-0.4-0.5-0.8 0.1-0.4 0.3-0.7 0.6-0.7 0.3 0.1 0.5 0.4 0.5 0.9-0.1 0.4-0.4 0.7-0.6 0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m43.3 24c0.3 0 0.6 0.3 0.7 0.7 0 0.4-0.2 0.8-0.5 0.8-0.3 0.1-0.5-0.2-0.6-0.6 0-0.5 0.2-0.8 0.4-0.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s6",
  d: "m33.2 26.8c-0.1-0.4 0-0.8 0.3-0.9 0.3-0.1 0.6 0.2 0.7 0.6 0.2 0.4 0 0.8-0.2 0.9-0.3 0-0.6-0.2-0.8-0.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m37.4 20.1c0.5 0.3 0.9 0.8 1.1 1.4 0 0 0-0.1 0.3-0.3 0.3-0.1 0.5-0.1 0.5-0.1 0 0-0.1 0.4-0.1 0.6 0 0.2 0 0.7-0.2 1.1-0.1 0.4-0.2 0.8-0.2 0.8-0.2-0.2-0.5-0.2-0.8-0.2-0.2 0-0.4 0.2-0.6 0.4 0 0-0.3-0.3-0.5-0.6-0.2-0.4-0.4-0.9-0.5-1-0.1-0.1-0.3-0.6-0.3-0.6 0 0 0.2 0 0.5 0 0.3 0.1 0.4 0.2 0.4 0.2-0.1-0.6 0.1-1.3 0.4-1.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m37.6 24.9q-0.2-0.2-0.3-0.5 0-0.3 0.1-0.6c0 0-0.4-0.2-0.8-0.3-0.3-0.1-0.9-0.1-1.1-0.1-0.1 0-0.5 0-0.5 0q0 0 0.2 0.2c0.1 0.2 0.2 0.4 0.2 0.4-0.6 0.1-1.1 0.5-1.4 1 0.5 0.3 1.1 0.5 1.6 0.4 0 0 0 0.2-0.1 0.4q0 0.3 0 0.3c0 0 0.3-0.1 0.5-0.2 0.2 0 0.7-0.2 1-0.4 0.3-0.3 0.6-0.6 0.6-0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m38.9 24.7q0.2-0.3 0.1-0.6 0-0.3-0.3-0.5c0 0 0.4-0.4 0.7-0.6 0.3-0.2 0.8-0.4 1-0.5 0.2 0 0.5-0.1 0.5-0.1q0-0.1-0.1 0.2c0 0.3 0 0.4 0 0.4 0.5 0 1.1 0.2 1.6 0.5-0.3 0.5-0.8 0.9-1.4 1 0 0 0.1 0.1 0.2 0.3q0.2 0.3 0.2 0.3c0 0-0.4 0-0.6 0-0.1 0-0.7 0-1-0.1-0.5-0.1-0.9-0.3-0.9-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m38.2 25.2c-0.5 0-1-0.4-1-1 0-0.5 0.5-0.9 1-0.9 0.6 0 1 0.4 1 0.9 0 0.6-0.4 1-1 1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m48.5 18.5c0.5 0.5 0.8 1.1 0.9 1.8 0 0 0.1-0.1 0.4-0.2 0.3-0.1 0.6-0.1 0.6-0.1 0 0-0.2 0.5-0.3 0.7 0 0.2-0.1 0.7-0.3 1.2-0.2 0.4-0.5 0.8-0.5 0.8-0.2-0.2-0.5-0.4-0.8-0.4-0.3 0-0.6 0.2-0.7 0.4 0 0-0.3-0.4-0.5-0.8-0.2-0.5-0.3-1-0.4-1.2-0.1-0.2-0.2-0.7-0.2-0.7 0 0 0.2 0 0.5 0.1 0.4 0.1 0.5 0.2 0.5 0.2 0-0.7 0.3-1.3 0.8-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m47.8 23.9q-0.2-0.2-0.3-0.6 0-0.4 0.3-0.6c0 0-0.4-0.3-0.9-0.5-0.3-0.2-1-0.3-1.2-0.4-0.2 0-0.5-0.1-0.5-0.1q0 0 0.1 0.3c0 0.3 0.1 0.5 0.1 0.5-0.6 0-1.3 0.4-1.7 0.8 0.4 0.5 1.1 0.8 1.7 0.8 0 0-0.1 0.2-0.1 0.5q-0.1 0.3-0.1 0.3c0 0 0.3-0.1 0.5-0.1 0.2-0.1 0.9-0.2 1.2-0.3 0.5-0.3 0.9-0.6 0.9-0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m49.3 23.9q0.2-0.2 0.2-0.6 0-0.4-0.2-0.6c0 0 0.4-0.3 0.8-0.5 0.4-0.2 1-0.3 1.2-0.4 0.2 0 0.6-0.1 0.6-0.1q0 0-0.1 0.3c-0.1 0.3-0.2 0.5-0.2 0.5 0.7 0 1.3 0.4 1.7 0.8-0.4 0.5-1 0.8-1.7 0.8 0 0 0.1 0.2 0.2 0.5q0.1 0.3 0.1 0.3c0 0-0.4-0.1-0.6-0.1-0.2-0.1-0.8-0.2-1.2-0.3-0.4-0.3-0.8-0.6-0.8-0.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m59.6 20.1c-0.4 0.3-0.9 0.8-1 1.4 0 0-0.1-0.1-0.3-0.3-0.3-0.1-0.5-0.1-0.5-0.1 0 0 0 0.4 0.1 0.6 0 0.2 0 0.7 0.1 1.1 0.1 0.4 0.3 0.8 0.3 0.8 0.2-0.2 0.5-0.2 0.7-0.2 0.3 0 0.5 0.2 0.6 0.4 0 0 0.3-0.3 0.6-0.6 0.2-0.4 0.4-0.9 0.5-1 0.1-0.1 0.3-0.6 0.3-0.6 0 0-0.2 0-0.5 0-0.3 0.1-0.4 0.2-0.4 0.2 0.1-0.6-0.1-1.3-0.5-1.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m59.4 24.9q0.3-0.2 0.3-0.5 0.1-0.3-0.1-0.6c0 0 0.4-0.2 0.9-0.3 0.3-0.1 0.9-0.1 1-0.1 0.2 0 0.5 0 0.5 0q0.1 0-0.1 0.2c-0.1 0.2-0.2 0.4-0.2 0.4 0.6 0.1 1.1 0.5 1.4 1-0.5 0.3-1.1 0.5-1.7 0.4 0 0 0.1 0.2 0.1 0.4q0.1 0.3 0.1 0.3c0 0-0.4-0.1-0.5-0.2-0.2 0-0.7-0.2-1-0.4-0.4-0.3-0.7-0.6-0.7-0.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m58.1 24.7q-0.1-0.3-0.1-0.6 0.1-0.3 0.3-0.5c0 0-0.3-0.4-0.6-0.6-0.3-0.2-0.8-0.4-1-0.5-0.2 0-0.5-0.1-0.5-0.1q0-0.1 0 0.2c0.1 0.3 0.1 0.4 0.1 0.4-0.6 0-1.2 0.2-1.6 0.5 0.3 0.5 0.8 0.9 1.4 1 0 0-0.1 0.1-0.3 0.3q-0.1 0.3-0.1 0.3c0 0 0.4 0 0.5 0 0.2 0 0.8 0 1.1-0.1 0.4-0.1 0.8-0.3 0.8-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m58.9 25.2c-0.6 0-1-0.4-1-1 0-0.5 0.4-0.9 1-0.9 0.5 0 0.9 0.4 0.9 0.9 0 0.6-0.4 1-0.9 1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m68.9 26.4c-0.3-0.3-0.8-0.2-1.1 0.1-0.4 0.3-0.5 0.8-0.2 1 0.2 0.3 0.7 0.2 1-0.1 0.4-0.3 0.5-0.8 0.3-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m67.5 27q0-0.3 0.3-0.5c0.3-0.3 0.8-0.4 1.1-0.1q0 0 0 0.1c0 0 0.5-1 1.1-1.3 0.6-0.3 1.6-0.3 1.6-0.3 0-0.7-0.6-1.3-1.3-1.3-0.5 0-0.9 0.2-1.2 0.5l-0.1-0.5c0 0-0.6 0.1-0.9 0.9-0.3 0.7 0.1 1.7 0.1 1.7 0 0-0.2-0.4-0.4-0.7-0.3-0.3-0.8-0.6-1.2-0.8-0.3-0.1-0.6-0.4-0.6-0.4q0 0 0 0.3c0 0.3 0 0.4 0 0.4-0.6-0.1-1.2 0-1.7 0.2 0.2 0.5 0.6 0.9 1.2 1.1 0 0-0.2 0.2-0.4 0.4q-0.2 0.2-0.2 0.2c0 0 0.4 0.1 0.6 0.1 0.2 0 0.8 0.1 1.2 0.1 0.3 0 0.6-0.1 0.8-0.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m28.2 26.4c0.3-0.3 0.7-0.2 1.1 0.1 0.3 0.3 0.5 0.8 0.2 1-0.2 0.3-0.7 0.2-1.1-0.1-0.3-0.3-0.4-0.8-0.2-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m29.6 27q-0.1-0.3-0.3-0.5c-0.4-0.3-0.8-0.4-1.1-0.1q0 0-0.1 0.1c0 0-0.5-1-1-1.3-0.6-0.3-1.6-0.3-1.6-0.3 0-0.7 0.6-1.3 1.3-1.3 0.5 0 0.9 0.2 1.1 0.5l0.1-0.5c0 0 0.7 0.1 0.9 0.9 0.3 0.7 0 1.7 0 1.7 0 0 0.2-0.4 0.4-0.7 0.2-0.3 0.8-0.6 1.1-0.8 0.3-0.1 0.7-0.4 0.7-0.4q0 0 0 0.3c0 0.3 0 0.4 0 0.4 0.5-0.1 1.2 0 1.7 0.2-0.2 0.5-0.6 0.9-1.2 1.1 0 0 0.2 0.2 0.4 0.4q0.2 0.2 0.2 0.2c0 0-0.4 0.1-0.6 0.1-0.2 0-0.8 0.1-1.2 0.1-0.3 0-0.6-0.1-0.8-0.1z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m48.5 24.3c-0.5 0-1-0.5-1-1 0-0.5 0.5-1 1-1 0.6 0 1 0.5 1 1 0 0.5-0.4 1-1 1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_17_",
  className: "s15",
  d: "m48.5 10.6c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp13)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m50.8 8.3v1.1h-4.5v-1.1h1.7v-3.1h-1.1v-1.1h1.1v-1h1.1v1h1v1.1h-1v3.1z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m50.1 8.3v1.1h-3.2v-1.1h1.1v-3.1h-1.1v-1.1h1.1v-1h1.1v1h1v1.1h-1v3.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp14)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m50.8 8.3v1.1h-4.5v-1.1h1.7v-3.1h-1.1v-1.1h1.1v-1h1.1v1h1v1.1h-1v3.1z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m49.1 6.7c0.8 0.3 1.4 1 1.4 1.9 0 1.1-0.9 2-2 2-1.1 0-2-0.9-2-2 0-0.9 0.6-1.7 1.5-1.9"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s10",
  d: "m48.7 92c-5.9 0-11.8-1.5-16.7-4-3.7-1.9-6.1-5.7-6.1-10v-15.7h22.7 22.8v15.7c0 4.3-2.4 8.1-6.1 10-4.9 2.5-10.7 4-16.6 4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s10",
  d: "m48.6 36h22.8v26.3h-22.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m25.9 36h22.7v26.3h-22.7z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_21_",
  fillRule: "evenodd",
  className: "s8",
  d: "m48.6 78c0 6.2-5 11.2-11.3 11.2-6.3 0-11.4-5-11.4-11.2v-15.7h22.7c0 0 0 15.7 0 15.7z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp15)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m30.8 61.7h2.7v29.1h-2.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp16)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m25.8 61.7h2.6v29.1h-2.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp17)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m35.9 61.7h2.7v29.1h-2.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp18)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m41 61.7h2.6v29.1h-2.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-Path",
  clipPath: "url(#cp19)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m46 61.7h2.7v29.1h-2.7z"
})), /*#__PURE__*/React.createElement("path", {
  id: "SVGID_21_",
  fillRule: "evenodd",
  className: "s5",
  d: "m48.6 78c0 6.2-5 11.2-11.3 11.2-6.3 0-11.4-5-11.4-11.2v-15.7h22.7c0 0 0 15.7 0 15.7z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m71.4 62.3v15.7c0 6.2-5.1 11.2-11.4 11.2-6.3 0-11.4-5-11.4-11.2v-15.7z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s16",
  d: ""
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s5",
  d: ""
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s16",
  d: ""
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s17",
  d: "m61.1 85q0.9-0.2 1.7-0.5l0.4 0.6q-0.3 0.2-0.6 0.3-0.7 0.2-1.5 0.3c-0.1 0.6-0.6 1-1.2 1-0.6 0-1.1-0.4-1.2-0.9q-0.8-0.2-1.5-0.4-0.3-0.1-0.6-0.3l0.4-0.6q0.1 0.1 0.3 0.1 0.2 0.1 0.3 0.1 0.6 0.2 1.2 0.3c0.1-0.3 0.4-0.6 0.7-0.7v-3.3h0.8v0.5 0.2 2.6c0.3 0.1 0.6 0.4 0.8 0.7zm2.1 0.1q0.5-0.2 1.1-0.5 0.3-0.2 0.5-0.5l0.2 0.9q-0.8 0.6-1.8 1l-0.6-0.6q0.3-0.1 0.6-0.3zm-6 0.3l-0.6 0.6q-1-0.4-1.9-1l0.2-0.9q0.3 0.3 0.6 0.5 0.5 0.3 1.1 0.5v0.1q0.3 0.1 0.6 0.2zm1.7-10.4q-0.1-0.1-0.1-0.2h-2v-0.8h1.9q0.1-0.1 0.1-0.2l-2.3-2.7 0.5-0.5 2.4 2.7q0 0 0.1-0.1v-2.9-0.7h0.8v3.6q0 0 0.1 0.1l2.3-2.8 0.6 0.5-2.3 2.7q0.1 0.2 0.1 0.3h1.9v0.8h-1.9q0 0.1-0.1 0.2l1.7 2.1 0.3 0.3 0.2 0.2-0.6 0.5-2.2-2.6q0 0-0.1 0.1v4.2h-0.8v-4.3q0 0-0.1 0l-2.2 2.6-0.6-0.5zm0.7-4.7l-0.8-0.2v-2.1l0.8-0.2v0.6 1.2zm-6.9-3.4v2.5h-0.7v-0.6-1.9c-0.5-0.2-0.9-0.7-0.9-1.2 0-0.7 0.6-1.2 1.3-1.2 0.5 0 1 0.3 1.1 0.8h2.1v0.8h-2.1q0 0.1-0.1 0.3l2.9 3.3-0.6 0.5-2.9-3.3c0 0 0 0-0.1 0zm-0.7 2.5v1.3 0.6l-0.8-0.2v-2.1l0.8-0.2v0.6zm3.9 14.5l-0.4 0.7q-0.3-0.2-0.5-0.4-0.7-0.5-1.2-1.1c-0.4 0.1-0.8 0-1.2-0.3-0.5-0.4-0.5-1.2-0.1-1.7l0.1-0.1q-0.4-0.8-0.5-1.6-0.1-0.4-0.1-0.7h0.7q0.1 1.1 0.5 2 0.4 0 0.7 0.1l1.9-2.2 0.6 0.4-1.9 2.3c0.2 0.4 0.2 0.9-0.1 1.3q0.7 0.8 1.5 1.3zm-3.8-4.5l-0.8-0.2-0.1-2.1 0.7-0.3v-1.2c-0.5-0.2-0.8-0.6-0.8-1.2 0-0.5 0.3-1 0.8-1.2v-1.9h0.1v-0.6h0.7v2.6c0.4 0.1 0.7 0.4 0.8 0.7h2.1v0.8h-2.1c-0.1 0.4-0.4 0.6-0.8 0.8v1.9h-0.8v-0.7 0.7 0.5q0 0.4 0.1 0.7 0 0.3 0.1 0.7zm1 2.9c0.2 0.2 0.6 0.2 0.7-0.1 0.2-0.2 0.2-0.5 0-0.7-0.2-0.2-0.6-0.1-0.8 0.1-0.2 0.2-0.1 0.5 0.1 0.7zm-0.4-5.5l0.8 0.2c0 0 0 0.8 0 1 0.1 0.3 0.1 1.1 0.1 1.1l-0.8 0.2q-0.1-0.6-0.1-1.3zm0.8 1.3q0-0.2 0 0 0 0 0 0zm2.4 4.9q0.9 0.6 1.9 1l-0.2 0.8q-0.1-0.1-0.2-0.1-1.1-0.4-2.1-1.2zm1.8-5.3l0.5 0.7-1.4 1.6-0.8-0.4zm-2.3 1.5l-0.4-0.7 1.4-1.6 0.7 0.3zm-3.1-4.1c0.3 0 0.6-0.2 0.6-0.5 0-0.3-0.3-0.5-0.6-0.5-0.2 0-0.5 0.2-0.5 0.5 0 0.3 0.3 0.5 0.5 0.5zm13.1 7.7c-0.3-0.4-0.3-0.9 0-1.4l-1.9-2.2 0.5-0.5 2 2.3q0.3-0.2 0.6-0.1 0.4-1 0.5-2h0.8q0 0.3-0.1 0.6-0.2 0.9-0.5 1.7l0.1 0.1c0.4 0.5 0.3 1.3-0.2 1.7-0.3 0.3-0.8 0.4-1.1 0.2q-0.6 0.6-1.2 1.1-0.3 0.3-0.6 0.5l-0.3-0.7q0.8-0.6 1.4-1.3zm2.5-3.9q0-0.4 0-0.7v-0.6-0.6l0.8 0.3-0.1 2.1-0.8 0.1q0.1-0.3 0.1-0.6zm-0.7-1.3v-1.9c-0.4-0.1-0.7-0.4-0.8-0.7h-2.1v-0.8h2.1c0.1-0.4 0.4-0.7 0.8-0.8v-2.6h0.7v0.7-0.7-1.2-0.7l0.8 0.3v2.1l-0.8 0.2v1.9c0.5 0.2 0.9 0.6 0.9 1.2 0 0.5-0.4 1-0.9 1.1v1.3 0.6zm-0.3 4.1c-0.2-0.2-0.5-0.2-0.7 0-0.3 0.2-0.3 0.5-0.1 0.7 0.2 0.2 0.5 0.3 0.7 0.1 0.3-0.2 0.3-0.5 0.1-0.8zm0.3-3.5q0 0.7-0.1 1.3l-0.8-0.3c0 0 0.1-0.8 0.1-1 0-0.2 0-1.1 0-1.1l0.8-0.2zm-0.8 0q0-0.1 0 0 0 0.1 0 0zm1.6-11.1v1.9 0.6h-0.8v-2.5q-0.1-0.1-0.1-0.1l-2.9 3.3-0.6-0.5 2.9-3.3q0-0.1 0-0.2h-2.1v-0.8h2.1c0.1-0.4 0.6-0.8 1.1-0.8 0.7 0 1.3 0.6 1.3 1.2 0 0.6-0.4 1-0.9 1.2zm-7.6 0v1.5h-0.7v-0.6-0.9c-0.4-0.1-0.7-0.4-0.8-0.8h-1.9v-0.8h1.9c0.1-0.4 0.6-0.8 1.1-0.8 0.6 0 1 0.4 1.2 0.8h1.9v0.8h-1.9c-0.1 0.4-0.4 0.7-0.8 0.8zm4.2 16.6c-0.7 0.5-1.4 1-2.3 1.3l-0.1-0.8q1-0.4 1.8-1zm-11.7-14.7l0.8 0.2v2.1l-0.8 0.2zm14.4 2.6l-0.8-0.2v-2.1l0.8-0.3zm-3.3 8.2l-0.8 0.4-1.4-1.6 0.5-0.7zm-0.8-2.1l-0.3-0.4 0.8-0.3 1.3 1.6-0.4 0.7zm-7.2-8.3l0.7-0.3 1.4 1.6-0.4 0.7zm1.1 2.4l-0.8 0.4-1.4-1.6 0.5-0.7zm5.3-0.6l-0.4-0.6 1.3-1.7 0.8 0.4zm2.3-1.5l0.4 0.7-1.4 1.6-0.7-0.3zm-9.6 4.4l0.2-0.8h2.2l0.2 0.8zm2.6 0.8l-0.2 0.7h-2.2l-0.2-0.7zm-5.2-8.6c0.3 0 0.5-0.3 0.5-0.5 0-0.3-0.2-0.6-0.5-0.6-0.3 0-0.5 0.3-0.5 0.6 0 0.2 0.2 0.5 0.5 0.5zm5.2-0.2l-0.3 0.8h-2.1l-0.2-0.8zm-2.6-0.7l0.2-0.8h2.1l0.3 0.8zm12.6 9.6c0.3 0 0.5-0.3 0.5-0.5 0-0.3-0.2-0.6-0.5-0.6-0.3 0-0.6 0.3-0.6 0.6 0 0.2 0.3 0.5 0.6 0.5zm-5.2-0.9l0.2-0.8h2.1l0.3 0.8zm2.6 0.8l-0.3 0.7h-2.1l-0.2-0.7zm-5 11.2c0.3 0 0.5-0.2 0.5-0.5 0-0.3-0.2-0.6-0.5-0.6-0.3 0-0.5 0.3-0.5 0.6 0 0.3 0.2 0.5 0.5 0.5zm0.4-4.3v-0.2-2.4l0.8 0.2v2.1zm-0.8 0l-0.8-0.2v-2.1l0.8-0.2zm8-15.5c0.3 0 0.5-0.2 0.5-0.5 0-0.3-0.2-0.5-0.5-0.5-0.3 0-0.6 0.2-0.6 0.5 0 0.3 0.3 0.5 0.6 0.5zm-7.6 0c0.2 0 0.5-0.2 0.5-0.5 0-0.3-0.3-0.5-0.5-0.5-0.3 0-0.6 0.2-0.6 0.5 0 0.3 0.3 0.5 0.6 0.5zm5-0.1l-0.3 0.7h-2.1l-0.2-0.7zm-2.6-0.8l0.2-0.8h2.2l0.2 0.8zm-2 2.4l0.8 0.3v2.1l-0.8 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s18",
  d: "m59.9 75.6c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.2 1.2-1.2 0.7 0 1.3 0.5 1.3 1.2 0 0.7-0.6 1.2-1.3 1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m60.2 42.5v-0.3l0.1-0.1c0 0-0.8 0-1.2-0.1-0.3-0.1-0.7-0.3-1-0.6-0.4-0.3-0.5-0.5-0.8-0.5-0.6-0.1-1.1 0.1-1.1 0.1 0 0 0.5 0.2 0.8 0.7 0.4 0.4 0.7 0.6 0.9 0.7 0.3 0.1 1.2 0 1.5 0 0.2 0 0.8 0.1 0.8 0.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s19",
  d: "m63.6 41.4c0 0 0 0.4 0 0.7 0.1 0.3-0.1 0.6 0 0.8 0 0.1 0.1 0.3 0.1 0.4 0.1 0.1 0.1 0.4 0.1 0.4 0 0-0.1-0.1-0.3-0.2-0.2-0.1-0.3-0.2-0.3-0.2 0 0 0.1 0.3 0.1 0.5 0 0.1 0.1 0.4 0.2 0.6 0.1 0.1 0.4 0.4 0.5 0.6 0.1 0.2 0 0.7 0 0.7 0 0-0.2-0.4-0.4-0.5-0.1 0-0.5-0.3-0.5-0.3 0 0 0.3 0.4 0.3 0.8 0 0.3-0.1 0.7-0.1 0.7 0 0-0.2-0.3-0.4-0.5-0.2-0.2-0.5-0.4-0.5-0.4 0 0 0.2 0.5 0.2 0.9 0 0.4 0 1.2 0 1.2 0 0-0.2-0.3-0.4-0.5-0.2-0.1-0.4-0.3-0.5-0.4 0-0.1 0.3 0.3 0.3 0.6 0 0.2 0.1 1.1 0.9 2.2 0.4 0.6 1 1.8 2.4 1.4 1.5-0.4 0.9-2.3 0.6-3.3-0.3-0.9-0.4-1.9-0.4-2.2 0-0.4 0.3-1.5 0.2-1.6 0-0.2-0.1-1 0.1-1.6 0.2-0.6 0.3-0.9 0.4-1.1 0.1-0.3 0.2-0.4 0.2-0.7 0.1-0.2 0.1-0.6 0.1-0.6 0 0 0.2 0.5 0.3 0.7 0.1 0.2 0.1 0.7 0.1 0.7 0 0 0-0.5 0.4-0.8 0.4-0.3 0.9-0.5 1-0.7 0.1-0.1 0.1-0.2 0.1-0.2 0 0 0 0.9-0.3 1.2-0.1 0.3-0.8 1-0.8 1 0 0 0.4-0.1 0.6-0.1 0.2 0 0.4 0 0.4 0 0 0-0.3 0.2-0.6 0.8-0.4 0.5-0.3 0.5-0.5 1-0.3 0.5-0.5 0.5-0.8 0.7-0.5 0.5-0.3 2.1-0.2 2.3 0.1 0.3 0.9 2.3 0.9 2.8 0.1 0.4 0.1 1.5-0.7 2.2-0.5 0.5-1.4 0.5-1.6 0.6-0.2 0.1-0.6 0.5-0.6 1.4 0 0.8 0.3 0.9 0.6 1.2 0.2 0.2 0.5 0.1 0.6 0.2 0 0.2 0.1 0.3 0.2 0.4 0.1 0.1 0.1 0.2 0.1 0.4 0 0.1-0.4 0.5-0.6 0.8-0.1 0.3-0.3 1.1-0.3 1.2 0 0.1-0.1 0.5 0 0.6 0 0 0.4 0.5 0.2 0.6-0.2 0.1-0.4-0.1-0.5-0.1-0.2 0.1-0.3 0.3-0.4 0.2-0.2 0-0.2-0.1-0.2-0.3 0-0.2 0-0.3-0.1-0.3q-0.1 0-0.1 0.2c-0.1 0.1-0.1 0.4-0.2 0.4-0.1 0-0.3-0.2-0.4-0.3 0 0-0.3-0.1-0.3-0.2-0.1-0.1 0.1-0.4 0.3-0.5 0.2 0 0.3-0.1 0.2-0.2q-0.1-0.1-0.3 0c-0.1 0.1-0.4 0-0.4-0.1 0.1-0.2 0.1-0.3 0.1-0.4 0-0.1-0.2-0.3 0-0.4 0.3-0.2 0.4 0.1 0.7 0.1 0.2-0.1 0.4-0.2 0.5-0.3 0.1-0.2 0-0.5-0.1-0.8-0.2-0.2-0.4-0.2-0.5-0.3 0-0.2-0.1-0.5-0.1-0.5 0 0 0 0.6 0 0.7-0.1 0.1 0 0.4 0 0.4 0 0-0.2-0.2-0.4-0.4-0.1-0.1-0.3-0.6-0.3-0.6 0 0 0 0.4 0 0.6 0 0.2 0.2 0.4 0.2 0.4-0.1 0.1-0.4-0.3-0.5-0.4-0.1 0-0.3-0.3-0.5-0.5-0.1-0.2-0.2-0.5-0.2-0.6 0-0.2-0.1-0.7 0-0.8 0.1-0.2 0.2-0.5 0.2-0.5 0 0-0.3 0-0.6 0-0.4 0-0.6-0.1-0.8 0.1-0.1 0.3 0 0.7 0.1 1.4 0.2 0.6 0.3 0.9 0.2 1 0 0.1-0.2 0.4-0.3 0.4-0.1 0.1-0.3 0.1-0.4 0-0.1 0-0.3-0.1-0.6-0.1-0.3 0-0.5 0-0.6 0-0.1-0.1-0.4-0.2-0.5-0.2-0.2 0.1-0.4 0.2-0.3 0.4 0.1 0.3-0.1 0.3-0.3 0.3-0.1 0-0.2-0.1-0.4-0.1-0.1-0.1-0.4 0-0.3-0.2 0-0.2 0.1-0.2 0.1-0.4 0.1-0.1 0.2-0.2 0.1-0.2-0.2 0-0.3 0-0.4 0 0 0.1-0.2 0.3-0.3 0.2-0.1 0-0.2-0.2-0.2-0.5 0-0.3-0.3-0.5 0-0.5 0.2 0 0.6 0.2 0.7 0 0-0.1 0-0.2-0.2-0.3-0.1-0.2-0.3-0.2-0.1-0.4 0.2-0.2 0.3-0.2 0.3-0.3 0.1 0 0.2-0.3 0.4-0.3 0.2 0.2 0 0.4 0.3 0.7 0.2 0.3 0.4 0.4 0.9 0.4 0.5-0.1 0.6-0.1 0.6-0.3 0-0.1 0-0.3-0.1-0.4 0-0.1 0.1-0.5 0.1-0.5 0 0-0.2 0.1-0.3 0.3 0 0.1-0.2 0.3-0.2 0.3 0 0 0-0.2 0-0.5 0-0.1 0.1-0.3 0-0.4 0-0.1-0.1-0.4-0.1-0.4 0 0 0 0.3-0.1 0.4 0 0.1-0.1 0.5-0.1 0.5 0 0-0.3-0.3-0.2-0.7 0.1-0.4 0-0.8 0.1-1 0.1-0.1 0.3-0.8 0.9-0.8 0.6 0 1.1 0 1.3 0 0.2 0 0.9-0.1 0.9-0.1 0 0-1.3-0.7-1.7-1-0.3-0.2-0.7-0.7-0.9-1-0.1-0.2-0.3-0.7-0.3-0.7 0 0-0.2 0-0.4 0.1-0.3 0.1-0.5 0.3-0.6 0.5-0.1 0.1-0.3 0.5-0.3 0.5 0 0 0-0.5 0-0.6 0-0.1 0-0.4 0-0.4 0 0-0.2 0.6-0.5 0.8-0.3 0.3-0.7 0.6-0.7 0.6 0 0 0.1-0.4 0.1-0.4 0-0.1 0.1-0.5 0.1-0.5 0 0-0.3 0.3-0.6 0.4-0.3 0.1-0.8 0-0.8 0.3-0.1 0.2 0 0.5 0 0.6-0.1 0.2-0.3 0.3-0.3 0.3 0 0-0.2-0.2-0.3-0.2-0.2 0-0.4 0.1-0.4 0.1 0 0-0.1-0.2 0-0.4 0-0.1 0.3-0.3 0.2-0.3-0.1-0.1-0.3 0-0.4 0-0.1 0.1-0.4 0.2-0.4 0 0.1-0.3 0.1-0.4 0.1-0.5q-0.1-0.3 0-0.3c0.1-0.1 0.5 0 0.6-0.1 0-0.1-0.1-0.2-0.4-0.3-0.3-0.1-0.4-0.2-0.2-0.4 0.1-0.1 0.1-0.1 0.2-0.3 0.1-0.1 0.1-0.3 0.3-0.2 0.3 0.1 0.2 0.4 0.5 0.5 0.2 0.1 0.8-0.1 1-0.1 0.1-0.1 0.5-0.4 0.6-0.5 0.2-0.1 0.8-0.5 0.8-0.5 0 0-0.4-0.3-0.5-0.4-0.1-0.1-0.4-0.5-0.5-0.5-0.1-0.1-0.7-0.3-0.8-0.3-0.2 0-0.8-0.2-0.8-0.2 0 0 0.2-0.1 0.3-0.2 0.1-0.1 0.3-0.3 0.4-0.3q0.2 0.1 0.2 0.1c0 0-0.6-0.1-0.7-0.1-0.1 0-0.5-0.3-0.6-0.3-0.1 0-0.4 0.1-0.4 0.1 0 0 0.4-0.2 0.7-0.3 0.2 0 0.5 0 0.5 0 0 0-0.5-0.2-0.6-0.3-0.1-0.2-0.2-0.4-0.3-0.5 0-0.1-0.1-0.2-0.2-0.3-0.2 0-0.4 0.2-0.6 0.2-0.1 0-0.2-0.1-0.2-0.3 0-0.2 0-0.1-0.1-0.3 0-0.1-0.2-0.3 0-0.4 0.2-0.1 0.6 0 0.6 0 0.1-0.1-0.2-0.3-0.4-0.4-0.1-0.1-0.4-0.3-0.3-0.4 0.2-0.1 0.3-0.2 0.4-0.3 0.1-0.1 0.2-0.4 0.3-0.3 0.2 0.1 0.4 0.6 0.6 0.5 0.1 0 0.1-0.4 0.1-0.5-0.1-0.2 0-0.4 0.1-0.4 0.1 0 0.2 0.2 0.4 0.2 0.2 0 0.5 0 0.5 0.1 0 0.2-0.1 0.4-0.3 0.5-0.1 0.2-0.2 0.5-0.1 0.7 0.1 0.2 0.3 0.6 0.5 0.7 0.3 0.2 0.6 0.3 0.9 0.4 0.2 0.2 0.8 0.7 1 0.7 0.2 0.1 0.4 0.2 0.4 0.2 0 0 0.2-0.1 0.5-0.1 0.3 0 0.9 0 1.2-0.1 0.3-0.1 0.6-0.3 0.5-0.5-0.1-0.3-0.7-0.5-0.6-0.7 0-0.2 0.2-0.2 0.6-0.2 0.3 0 0.8 0.1 0.9-0.4 0.1-0.5 0.1-0.8-0.4-1-0.5-0.1-0.8-0.1-0.9-0.4-0.1-0.4-0.2-0.5-0.1-0.6 0.1-0.1 0.3-0.1 0.6-0.2 0.4 0 0.8 0 0.9-0.1 0.1-0.1 0.2-0.3 0.3-0.4 0.1-0.1 0.7-0.2 0.7-0.2 0 0 0.7 0.3 1.3 0.8 0.5 0.4 1 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s20",
  d: "m58.9 41.1c0 0-0.1-0.2-0.1-0.3 0-0.1 0-0.1 0-0.1 0 0 0.3 0 0.3 0.1 0 0.1-0.1 0.1-0.1 0.2 0 0-0.1 0.1-0.1 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s20",
  d: "m60.7 40.4v-0.2c0 0 0.3 0 0.5 0.2 0.3 0.1 0.4 0.4 0.4 0.4 0 0.1-0.2-0.1-0.4-0.1 0 0-0.1 0-0.2 0q-0.1 0-0.1-0.1c-0.1-0.1 0-0.1 0-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m63.2 43.3c0 0-0.1-0.2-0.2-0.3 0-0.1-0.1-0.2-0.1-0.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m53.8 41c0 0 0.3 0.2 0.4 0.2 0.2 0 0.4 0 0.4 0 0 0 0.1-0.2 0-0.4 0-0.6-0.5-0.7-0.5-0.7 0 0 0.1 0.4 0 0.5-0.1 0.2-0.3 0.4-0.3 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m52.8 41.5c0 0-0.2-0.4-0.6-0.3-0.4 0-0.7 0.4-0.7 0.4 0 0 0.5 0 0.6 0 0.2 0.1 0.2 0.4 0.2 0.4 0 0 0.2-0.1 0.3-0.2 0.1-0.1 0.2-0.3 0.2-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m52.3 43c0 0-0.3 0-0.5 0.3-0.2 0.2-0.2 0.6-0.2 0.6 0 0 0.2-0.2 0.4-0.2 0.2 0 0.6 0 0.6 0 0 0-0.1-0.2-0.1-0.3 0-0.2-0.2-0.4-0.2-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s16",
  d: ""
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s20",
  d: "m58.9 42.9l0.2-0.2 0.1 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s20",
  d: "m59.3 42.9l0.2-0.2 0.1 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s20",
  d: "m59.1 41.4l0.4 0.1-0.3 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s20",
  d: "m59.6 41.5l0.3 0.1-0.3 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m57.1 44.5c0 0-0.4 0.1-0.5 0.3-0.2 0.2-0.2 0.5-0.2 0.5 0 0 0.3-0.3 0.7-0.2 0.4 0.1 0.5 0.2 0.6 0.2 0.2 0 0.6-0.2 0.6-0.2 0 0-0.3 0.4-0.3 0.7 0 0.3 0.1 0.4 0.1 0.5-0.1 0.4-0.3 0.8-0.3 0.8 0 0 0.1-0.1 0.5-0.2 0.3-0.1 0.6-0.2 0.8-0.4 0.2-0.1 0.4-0.4 0.4-0.4 0 0-0.1 0.4 0 0.6 0.1 0.2 0.1 0.8 0.1 0.8 0 0 0.2-0.2 0.4-0.3 0.1 0 0.3-0.2 0.4-0.3 0-0.1 0.1-0.5 0.1-0.5 0 0 0.1 0.4 0.2 0.6 0.1 0.2 0.3 0.8 0.3 0.8 0 0 0.1-0.4 0.3-0.5 0.1-0.2 0.3-0.4 0.3-0.5 0-0.2 0-0.4 0-0.4l0.1 0.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m56.6 47.1c0 0 0.2-0.4 0.4-0.6 0.2-0.1 0.5-0.3 0.6-0.3 0-0.1 0.4-0.3 0.4-0.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m58.4 48.4c0 0 0.5-0.3 0.7-0.4 0.3-0.2 0.5-0.5 0.5-0.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m53.5 47.7c0 0-0.2-0.2-0.6-0.1-0.3 0.1-0.5 0.5-0.5 0.5 0 0 0.3-0.1 0.4-0.1 0.2 0.1 0.3 0.2 0.3 0.2 0 0 0.2-0.1 0.2-0.2 0.1-0.1 0.2-0.3 0.2-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m53.1 49.1c0 0-0.3 0-0.5 0.2-0.3 0.2-0.3 0.6-0.3 0.6 0 0 0.2-0.2 0.4-0.2 0.2 0 0.4 0.1 0.4 0.1 0 0 0-0.2 0.1-0.3 0-0.1-0.1-0.4-0.1-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m53.7 50.4c0 0 0 0.4 0.2 0.6 0.2 0.3 0.5 0.3 0.5 0.3 0 0-0.1-0.2-0.1-0.4-0.1-0.2 0.1-0.3 0.1-0.3 0 0-0.1-0.2-0.3-0.2-0.2 0-0.4 0-0.4 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s5",
  d: "m61.3 51.1c0 0 0.9 0.6 0.9 1 0 0.5-0.5 1.2-0.5 1.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m57.1 53.8c0 0-0.3-0.4-0.6-0.3-0.3 0-0.6 0.3-0.6 0.3 0 0 0.4 0 0.5 0.1 0.1 0.1 0.2 0.3 0.2 0.3 0 0 0.1-0.1 0.2-0.2 0.1 0 0.3-0.2 0.3-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m56.1 55.1c0 0-0.4-0.1-0.6 0.1-0.3 0.3-0.2 0.7-0.2 0.7 0 0 0.2-0.3 0.4-0.3 0.3 0 0.5 0.2 0.5 0.2 0 0 0-0.3 0-0.4-0.1-0.1-0.1-0.3-0.1-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m57 56.5c0 0-0.2 0.3-0.1 0.5 0.2 0.3 0.5 0.4 0.5 0.4 0 0-0.1-0.2-0.1-0.4 0.1-0.2 0.4-0.4 0.4-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m62.6 57c0 0-0.4 0-0.6 0.1-0.2 0.1-0.3 0.6-0.3 0.6 0 0 0.3-0.3 0.5-0.2 0.3 0 0.5 0.1 0.5 0.1 0 0 0-0.2 0-0.3 0-0.1-0.1-0.3-0.1-0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m62.8 58.5c0 0-0.3 0.3-0.2 0.5 0.1 0.3 0.3 0.5 0.3 0.5 0 0 0-0.3 0.1-0.5 0.2-0.1 0.5-0.1 0.5-0.1 0 0-0.3-0.3-0.4-0.3 0 0-0.3-0.1-0.3-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m64.2 58.9c0 0-0.1 0.4 0.1 0.6 0.3 0.2 0.5 0.3 0.5 0.3 0 0-0.2-0.4-0.1-0.6 0-0.2 0.2-0.4 0.2-0.4 0 0-0.3-0.1-0.4-0.1 0 0.1-0.3 0.2-0.3 0.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s21",
  d: "m49.8 85c0.9 0.3 1.4 1.1 1.4 1.9 0 1.2-1 2-2.4 2-1.3 0-2.4-0.8-2.4-2 0-0.8 0.4-1.8 1.3-1.8q0.1 0-0.1-0.3c-0.1-0.1-0.3-0.3-0.3-0.3 0 0 0.4 0 0.6 0 0.2 0.1 0.4 0.3 0.4 0.3 0 0 0.1-0.2 0.2-0.4 0.1-0.1 0.3-0.2 0.3-0.2 0 0 0.2 0.1 0.3 0.3 0.1 0.1 0.1 0.2 0.1 0.2 0 0 0.2-0.1 0.4-0.2 0.1-0.1 0.3-0.1 0.3-0.1 0 0 0 0.2-0.1 0.3 0 0.1 0 0.3 0 0.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m48.6 90.1c0 0-1.8-1.2-2.6-1.4-1-0.2-2.1-0.1-2.6-0.1 0 0 0.6 0.5 0.8 0.7 0.3 0.3 1.1 0.8 1.6 0.9 1.5 0.4 2.8-0.1 2.8-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m49.1 90.2c0 0 1.2-1.2 2.4-1.4 1.4-0.2 2.3 0.1 2.9 0.3 0 0-0.5 0.2-0.7 0.4-0.3 0.2-0.9 0.7-1.9 0.7-1 0.1-2.1-0.1-2.2 0-0.2 0-0.5 0-0.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m48.8 88.7c-0.5-0.5-0.8-1.1-0.8-1.8 0-0.7 0.3-1.3 0.8-1.7 0.4 0.4 0.7 1 0.7 1.7 0 0.7-0.3 1.3-0.7 1.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s7",
  d: "m48.3 91.2c0 0 0.3-0.7 0.3-1.3 0-0.5 0-1 0-1 0 0 0.1 0 0.2 0q0.1 0 0.1 0c0 0 0.2 0.5 0.2 1 0 0.5-0.1 1.1-0.1 1.1 0 0-0.2 0.1-0.3 0.1-0.1 0.1-0.4 0.1-0.4 0.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m71.6 23.9c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m72.3 22.6c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.4 0.5-0.4 0.2 0 0.5 0.2 0.5 0.4 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m72.7 21.2c-0.2 0-0.5-0.2-0.5-0.5 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m72.8 19.6c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.4 0.5-0.4 0.3 0 0.5 0.2 0.5 0.4 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m72.4 18.1c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m71.7 16.7c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.2 0 0.4 0.3 0.4 0.5 0 0.3-0.2 0.5-0.4 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m70.6 15.6c-0.2 0-0.5-0.3-0.5-0.5 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m69.5 14.6c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.2 0 0.4 0.3 0.4 0.5 0 0.3-0.2 0.5-0.4 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m68 13.8c-0.2 0-0.5-0.2-0.5-0.4 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.4-0.5 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m66.6 13.3c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.5 0.2 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m64.9 13c-0.2 0-0.5-0.2-0.5-0.5 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m63.4 12.9c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.5 0.2 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m61.8 13c-0.2 0-0.5-0.3-0.5-0.5 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m60.3 13c-0.3 0-0.5-0.3-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m61.1 14.3c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m61.4 15.8c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m61.5 17.3c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.2 0 0.4 0.3 0.4 0.5 0 0.3-0.2 0.5-0.4 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m61 18.7c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m60.2 19.9c-0.3 0-0.5-0.2-0.5-0.4 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.5 0.2 0.5 0.5 0 0.2-0.3 0.4-0.5 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m59.2 12c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.2 0 0.5 0.3 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m57.8 11.2c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.4 0.5-0.4 0.3 0 0.5 0.2 0.5 0.4 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m56.3 10.8c-0.3 0-0.5-0.3-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m54.8 10.5c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.5 0.2 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m53.2 10.5c-0.2 0-0.5-0.2-0.5-0.5 0-0.2 0.3-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m51.6 10.8c-0.2 0-0.4-0.2-0.4-0.5 0-0.3 0.2-0.5 0.4-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m50.2 11.3c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m25.3 23.9c-0.2 0-0.5-0.2-0.5-0.5 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m24.7 22.6c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.4 0.5-0.4 0.2 0 0.5 0.2 0.5 0.4 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m24.2 21.2c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m24.2 19.6c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.4 0.5-0.4 0.2 0 0.4 0.2 0.4 0.4 0 0.3-0.2 0.5-0.4 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m24.5 18.1c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m25.3 16.7c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m26.3 15.6c-0.3 0-0.5-0.3-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m27.5 14.6c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m28.9 13.8c-0.3 0-0.5-0.2-0.5-0.4 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.4-0.5 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m30.4 13.3c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.5 0.2 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m32 13c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m33.6 12.9c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.5 0.2 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m35.1 13c-0.3 0-0.5-0.3-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m36.6 13c-0.3 0-0.5-0.3-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m35.9 14.3c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.2 0 0.5 0.3 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m35.5 15.8c-0.2 0-0.5-0.2-0.5-0.5 0-0.2 0.3-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m35.5 17.3c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m35.9 18.7c-0.2 0-0.5-0.2-0.5-0.5 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m36.8 19.9c-0.3 0-0.5-0.2-0.5-0.4 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.4-0.5 0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m37.8 12c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.2 0 0.5 0.3 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m39.1 11.2c-0.2 0-0.5-0.2-0.5-0.5 0-0.2 0.3-0.4 0.5-0.4 0.3 0 0.5 0.2 0.5 0.4 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m40.6 10.8c-0.2 0-0.5-0.3-0.5-0.5 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.2-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m42.2 10.5c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m43.7 10.5c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.3 0 0.5 0.3 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m45.3 10.8c-0.3 0-0.5-0.2-0.5-0.5 0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.5-0.5 0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s6",
  d: "m46.8 11.3c-0.3 0-0.5-0.2-0.5-0.5 0-0.2 0.2-0.5 0.5-0.5 0.2 0 0.5 0.3 0.5 0.5 0 0.3-0.3 0.5-0.5 0.5z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m43.7 58.6h-12.8v-3.3h1.8v-6.9h-0.9v-3.1h1.5v-2.1h-0.7v-1.6h0.6v0.5h0.6v-0.5h0.7v0.5h0.7v-0.5h0.5v1.6h-0.6v2.1h1.3v-4.6h-0.8v-1.7h0.6v0.4h0.7v-0.4h0.9v0.4h0.7v-0.4h0.6v1.7h-0.9v4.6h1.2v-2.1h-0.6v-1.6h0.6v0.5h0.6v-0.5h0.7v0.5h0.6v-0.5h0.6v1.6h-0.6v2.1h1.5v3.1h-0.9v6.9h1.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m34 50.7c0-0.3 0.2-0.6 0.5-0.6 0.4 0 0.6 0.3 0.6 0.6v1.3h-1.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m39.5 50.7c0-0.3 0.2-0.6 0.6-0.6 0.3 0 0.5 0.3 0.5 0.6v1.3h-1.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s9",
  d: "m36.1 56.6c0-0.7 0.5-1.2 1.2-1.2 0.7 0 1.2 0.5 1.2 1.2v2h-2.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s2",
  d: "m48.7 70.8c-4.1 0-7.4-3.9-7.4-8.6 0-4.8 3.3-8.6 7.4-8.6 4 0 7.3 3.8 7.3 8.6 0 4.7-3.3 8.6-7.3 8.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s9",
  d: "m48.7 68.5c-2.9 0-5.2-2.8-5.2-6.3 0-3.5 2.3-6.4 5.2-6.4 2.8 0 5.1 2.9 5.1 6.4 0 3.5-2.3 6.3-5.1 6.3z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m46.2 57.8c0 0-0.6 0.7-0.6 1.4 0 0.6 0.3 1.2 0.3 1.2-0.1-0.3-0.4-0.5-0.7-0.5-0.4 0-0.7 0.3-0.7 0.7 0 0.1 0.1 0.3 0.1 0.3l0.3 0.5c0-0.2 0.2-0.3 0.4-0.3 0.3 0 0.5 0.3 0.5 0.5q0 0.1 0 0.1h-0.6v0.5h0.5l-0.3 0.8 0.4-0.2 0.4 0.4 0.4-0.4 0.5 0.2-0.4-0.8h0.5v-0.5h-0.6q0 0 0-0.1c0-0.2 0.3-0.5 0.5-0.5 0.2 0 0.4 0.1 0.5 0.3l0.2-0.5c0 0 0.1-0.2 0.1-0.3 0-0.4-0.3-0.7-0.7-0.7-0.3 0-0.5 0.2-0.6 0.5 0 0 0.2-0.6 0.2-1.2 0-0.7-0.6-1.4-0.6-1.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m45.2 61.7h2v0.5h-2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m51 57.8c0 0-0.6 0.7-0.6 1.4 0 0.6 0.3 1.2 0.3 1.2-0.1-0.3-0.4-0.5-0.7-0.5-0.3 0-0.6 0.3-0.6 0.7 0 0.1 0 0.3 0.1 0.3l0.2 0.5c0.1-0.2 0.2-0.3 0.4-0.3 0.3 0 0.5 0.3 0.5 0.5q0 0.1 0 0.1h-0.6v0.5h0.5l-0.3 0.8 0.5-0.2 0.3 0.4 0.4-0.4 0.5 0.2-0.4-0.8h0.5v-0.5h-0.5q-0.1 0-0.1-0.1c0-0.2 0.3-0.5 0.5-0.5 0.2 0 0.4 0.1 0.5 0.3l0.2-0.5c0 0 0.1-0.2 0.1-0.3 0-0.4-0.3-0.7-0.7-0.7-0.3 0-0.5 0.2-0.6 0.5 0 0 0.2-0.6 0.2-1.2 0-0.7-0.6-1.4-0.6-1.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m50 61.7h2v0.5h-2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m48.6 62.1c0 0-0.6 0.7-0.6 1.4 0 0.6 0.3 1.2 0.3 1.2-0.1-0.3-0.4-0.5-0.7-0.5-0.4 0-0.7 0.3-0.7 0.7 0 0.1 0.1 0.3 0.2 0.4l0.2 0.4c0-0.2 0.2-0.2 0.4-0.2 0.3 0 0.5 0.2 0.5 0.4q0 0.1 0 0.1h-0.6v0.5h0.5l-0.3 0.8 0.4-0.2 0.4 0.4 0.4-0.4 0.5 0.2-0.4-0.8h0.5v-0.5h-0.5q-0.1 0-0.1-0.1c0-0.2 0.3-0.4 0.5-0.4 0.2 0 0.4 0 0.5 0.2l0.2-0.4c0-0.1 0.1-0.3 0.1-0.4 0-0.4-0.3-0.7-0.7-0.7-0.3 0-0.5 0.2-0.6 0.5 0 0 0.2-0.6 0.2-1.2 0-0.7-0.6-1.4-0.6-1.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m47.6 66h2v0.5h-2z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m63.3 39.4h-0.1c0 0.1 0 0.1-0.1 0.2-0.1 0.1-0.3 0.1-0.4 0q-0.1 0-0.1-0.2-0.1 0.1-0.2 0c-0.1 0-0.1-0.2 0-0.3q0-0.1 0-0.1v-0.2l-0.2 0.1v0.1c-0.1 0.1-0.3 0.1-0.3 0-0.1 0-0.1-0.1-0.1-0.1 0 0 0 0.1-0.1 0.1-0.2 0-0.3-0.5-0.3-0.7l-0.1 0.1c0 0 0.1 0.4 0 0.7 0 0.2-0.1 0.5-0.1 0.5 0.3 0.1 0.9 0.4 1.4 0.8 0.5 0.4 0.9 0.8 1 1.1 0 0 0.3-0.1 0.5-0.2 0.3-0.1 0.7-0.1 0.7-0.1l0.1-0.1c-0.2 0-0.8 0-0.7-0.2 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1 0-0.1-0.1-0.1-0.2 0-0.3v-0.1l0.1-0.2-0.2 0.1q0 0-0.1 0c-0.1 0.1-0.3 0.1-0.4 0q0-0.1 0-0.2-0.1 0.1-0.2 0c-0.1-0.1-0.2-0.2-0.1-0.4 0.1-0.1 0.2-0.1 0.2-0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s20",
  d: "m62.4 39.8q0.1 0 0.1 0.1-0.1 0-0.2 0 0-0.1 0-0.2 0.1 0 0.1 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s20",
  d: "m62.8 40.1l-0.2-0.1q0 0 0-0.1 0 0 0.1 0l0.1 0.1 0.2 0.2q0 0 0 0 0 0.1-0.1 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s20",
  d: "m62 39.6l-0.1-0.1q-0.1 0-0.1-0.1 0 0 0.1 0l0.1 0.1h0.1q0.1 0.1 0.1 0.1-0.1 0.1-0.1 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s20",
  d: "m61.6 39.2q0.1 0.1 0 0.1 0 0.1-0.1 0 0 0 0-0.1 0 0 0.1 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s20",
  d: "m63.1 40.5q0-0.1 0-0.1 0-0.1 0.1 0 0.1 0 0 0.1 0 0-0.1 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s20",
  d: "m63.5 40.8l0.1 0.1q0 0 0.1 0 0 0 0-0.1l-0.1-0.1-0.1-0.1q-0.1 0-0.1 0 0 0 0 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s20",
  d: "m63.8 41.2q0-0.1 0-0.1 0-0.1 0.1 0 0.1 0 0 0.1 0 0-0.1 0z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m62.7 38.3h-0.3v0.4 0.1h0.1l0.3-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m62 38.5l-0.1 0.3 0.5 0.1v-0.1l-0.2-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m62.8 39.1l-0.2 0.1-0.3-0.4 0.1-0.1 0.4 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m62.4 38.9q-0.1 0-0.1-0.1 0-0.1 0.1-0.1 0.1 0 0.1 0.1 0 0.1-0.1 0.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m61.3 38.3c0 0-0.1-0.2-0.1-0.3-0.1-0.1-0.2-0.2-0.2-0.2 0-0.1 0.2-0.1 0.4 0 0.2 0.2 0 0.4 0 0.4 0 0-0.1 0.1-0.1 0.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m61.8 38.5l-0.2 0.1-0.3-0.2v-0.1-0.1h0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m61.4 38.2q0 0 0 0.1 0 0.2-0.1 0.1-0.1 0-0.1-0.1 0.1-0.1 0.2-0.1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m63.7 39h-0.3l-0.1 0.4h0.1l0.4-0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m63 39.1l-0.1 0.3 0.4 0.1h0.1v-0.1l-0.2-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m63.7 39.7l-0.2 0.1-0.2-0.3v-0.1h0.1l0.4 0.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m63.3 39.6q-0.1-0.1-0.1-0.2 0-0.1 0.1-0.1 0.2 0 0.2 0.1 0 0.1-0.2 0.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m64.6 39.9v0.2l-0.3 0.2-0.1-0.1 0.1-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m64.5 40.6l-0.2 0.1-0.2-0.4v-0.1h0.1l0.4 0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m63.8 39.9v0.2l0.3 0.2h0.1v-0.1l-0.1-0.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m64.2 40.4q-0.1 0-0.2-0.2 0.1-0.1 0.2-0.1 0.1 0 0.1 0.1 0 0.2-0.1 0.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m64.9 41.2c0 0 0.2 0 0.3 0 0.1 0 0.3 0.1 0.3 0.1 0 0 0-0.1-0.1-0.3-0.2-0.2-0.4 0.1-0.4 0.1 0 0-0.1 0-0.1 0.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m64.6 40.8l-0.1 0.2 0.4 0.2h0.1l-0.1-0.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "s3",
  d: "m64.8 41.2q-0.1-0.1 0-0.1 0.1-0.1 0.2 0 0 0.1-0.1 0.1-0.1 0.1-0.1 0z"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "_x31_00"
}), /*#__PURE__*/React.createElement("g", {
  id: "Foreground"
})));

var SvgMciuLogo = function SvgMciuLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 303 96",
    width: 303,
    height: 96,
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMciuLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MCIU_logo.6c8b1219.svg";
export { ForwardRef as ReactComponent };